/** VERSION: 0.0.3 Please do not delete this line. Thank you! **/
if(typeof lazySizes !== 'function' && typeof lazySizes !== 'object'){
    /*! lazysizes - v4.1.8 */
    !function (a, b) { var c = b(a, a.document); a.lazySizes = c, "object" == typeof module && module.exports && (module.exports = c) }(window, function (a, b) { "use strict"; if (b.getElementsByClassName) { var c, d, e = b.documentElement, f = a.Date, g = a.HTMLPictureElement, h = "addEventListener", i = "getAttribute", j = a[h], k = a.setTimeout, l = a.requestAnimationFrame || k, m = a.requestIdleCallback, n = /^picture$/i, o = ["load", "error", "lazyincluded", "_lazyloaded"], p = {}, q = Array.prototype.forEach, r = function (a, b) { return p[b] || (p[b] = new RegExp("(\\s|^)" + b + "(\\s|$)")), p[b].test(a[i]("class") || "") && p[b] }, s = function (a, b) { r(a, b) || a.setAttribute("class", (a[i]("class") || "").trim() + " " + b) }, t = function (a, b) { var c; (c = r(a, b)) && a.setAttribute("class", (a[i]("class") || "").replace(c, " ")) }, u = function (a, b, c) { var d = c ? h : "removeEventListener"; c && u(a, b), o.forEach(function (c) { a[d](c, b) }) }, v = function (a, d, e, f, g) { var h = b.createEvent("Event"); return e || (e = {}), e.instance = c, h.initEvent(d, !f, !g), h.detail = e, a.dispatchEvent(h), h }, w = function (b, c) { var e; !g && (e = a.picturefill || d.pf) ? (c && c.src && !b[i]("srcset") && b.setAttribute("srcset", c.src), e({ reevaluate: !0, elements: [b] })) : c && c.src && (b.src = c.src) }, x = function (a, b) { return (getComputedStyle(a, null) || {})[b] }, y = function (a, b, c) { for (c = c || a.offsetWidth; c < d.minSize && b && !a._lazysizesWidth;)c = b.offsetWidth, b = b.parentNode; return c }, z = function () { var a, c, d = [], e = [], f = d, g = function () { var b = f; for (f = d.length ? e : d, a = !0, c = !1; b.length;)b.shift()(); a = !1 }, h = function (d, e) { a && !e ? d.apply(this, arguments) : (f.push(d), c || (c = !0, (b.hidden ? k : l)(g))) }; return h._lsFlush = g, h }(), A = function (a, b) { return b ? function () { z(a) } : function () { var b = this, c = arguments; z(function () { a.apply(b, c) }) } }, B = function (a) { var b, c = 0, e = d.throttleDelay, g = d.ricTimeout, h = function () { b = !1, c = f.now(), a() }, i = m && g > 49 ? function () { m(h, { timeout: g }), g !== d.ricTimeout && (g = d.ricTimeout) } : A(function () { k(h) }, !0); return function (a) { var d; (a = !0 === a) && (g = 33), b || (b = !0, d = e - (f.now() - c), d < 0 && (d = 0), a || d < 9 ? i() : k(i, d)) } }, C = function (a) { var b, c, d = 99, e = function () { b = null, a() }, g = function () { var a = f.now() - c; a < d ? k(g, d - a) : (m || e)(e) }; return function () { c = f.now(), b || (b = k(g, d)) } }; !function () { var b, c = { lazyClass: "lazyload", loadedClass: "lazyloaded", loadingClass: "lazyloading", preloadClass: "lazypreload", errorClass: "lazyerror", autosizesClass: "lazyautosizes", srcAttr: "data-src", srcsetAttr: "data-srcset", sizesAttr: "data-sizes", minSize: 40, customMedia: {}, init: !0, expFactor: 1.5, hFac: .8, loadMode: 2, loadHidden: !0, ricTimeout: 0, throttleDelay: 125 }; d = a.lazySizesConfig || a.lazysizesConfig || {}; for (b in c) b in d || (d[b] = c[b]); a.lazySizesConfig = d, k(function () { d.init && F() }) }(); var D = function () { var g, l, m, o, p, y, D, F, G, H, I, J, K = /^img$/i, L = /^iframe$/i, M = "onscroll" in a && !/(gle|ing)bot/.test(navigator.userAgent), N = 0, O = 0, P = 0, Q = -1, R = function (a) { P-- , (!a || P < 0 || !a.target) && (P = 0) }, S = function (a) { return null == J && (J = "hidden" == x(b.body, "visibility")), J || "hidden" != x(a.parentNode, "visibility") && "hidden" != x(a, "visibility") }, T = function (a, c) { var d, f = a, g = S(a); for (F -= c, I += c, G -= c, H += c; g && (f = f.offsetParent) && f != b.body && f != e;)(g = (x(f, "opacity") || 1) > 0) && "visible" != x(f, "overflow") && (d = f.getBoundingClientRect(), g = H > d.left && G < d.right && I > d.top - 1 && F < d.bottom + 1); return g }, U = function () { var a, f, h, j, k, m, n, p, q, r, s, t, u = c.elements; if ((o = d.loadMode) && P < 8 && (a = u.length)) { for (f = 0, Q++; f < a; f++)if (u[f] && !u[f]._lazyRace) if (!M || c.prematureUnveil && c.prematureUnveil(u[f])) aa(u[f]); else if ((p = u[f][i]("data-expand")) && (m = 1 * p) || (m = O), r || (r = !d.expand || d.expand < 1 ? e.clientHeight > 500 && e.clientWidth > 500 ? 500 : 370 : d.expand, c._defEx = r, s = r * d.expFactor, t = d.hFac, J = null, O < s && P < 1 && Q > 2 && o > 2 && !b.hidden ? (O = s, Q = 0) : O = o > 1 && Q > 1 && P < 6 ? r : N), q !== m && (y = innerWidth + m * t, D = innerHeight + m, n = -1 * m, q = m), h = u[f].getBoundingClientRect(), (I = h.bottom) >= n && (F = h.top) <= D && (H = h.right) >= n * t && (G = h.left) <= y && (I || H || G || F) && (d.loadHidden || S(u[f])) && (l && P < 3 && !p && (o < 3 || Q < 4) || T(u[f], m))) { if (aa(u[f]), k = !0, P > 9) break } else !k && l && !j && P < 4 && Q < 4 && o > 2 && (g[0] || d.preloadAfterLoad) && (g[0] || !p && (I || H || G || F || "auto" != u[f][i](d.sizesAttr))) && (j = g[0] || u[f]); j && !k && aa(j) } }, V = B(U), W = function (a) { var b = a.target; if (b._lazyCache) return void delete b._lazyCache; R(a), s(b, d.loadedClass), t(b, d.loadingClass), u(b, Y), v(b, "lazyloaded") }, X = A(W), Y = function (a) { X({ target: a.target }) }, Z = function (a, b) { try { a.contentWindow.location.replace(b) } catch (c) { a.src = b } }, $ = function (a) { var b, c = a[i](d.srcsetAttr); (b = d.customMedia[a[i]("data-media") || a[i]("media")]) && a.setAttribute("media", b), c && a.setAttribute("srcset", c) }, _ = A(function (a, b, c, e, f) { var g, h, j, l, o, p; (o = v(a, "lazybeforeunveil", b)).defaultPrevented || (e && (c ? s(a, d.autosizesClass) : a.setAttribute("sizes", e)), h = a[i](d.srcsetAttr), g = a[i](d.srcAttr), f && (j = a.parentNode, l = j && n.test(j.nodeName || "")), p = b.firesLoad || "src" in a && (h || g || l), o = { target: a }, s(a, d.loadingClass), p && (clearTimeout(m), m = k(R, 2500), u(a, Y, !0)), l && q.call(j.getElementsByTagName("source"), $), h ? a.setAttribute("srcset", h) : g && !l && (L.test(a.nodeName) ? Z(a, g) : a.src = g), f && (h || l) && w(a, { src: g })), a._lazyRace && delete a._lazyRace, t(a, d.lazyClass), z(function () { var b = a.complete && a.naturalWidth > 1; p && !b || (b && s(a, "ls-is-cached"), W(o), a._lazyCache = !0, k(function () { "_lazyCache" in a && delete a._lazyCache }, 9)), "lazy" == a.loading && P-- }, !0) }), aa = function (a) { if (!a._lazyRace) { var b, c = K.test(a.nodeName), e = c && (a[i](d.sizesAttr) || a[i]("sizes")), f = "auto" == e; (!f && l || !c || !a[i]("src") && !a.srcset || a.complete || r(a, d.errorClass) || !r(a, d.lazyClass)) && (b = v(a, "lazyunveilread").detail, f && E.updateElem(a, !0, a.offsetWidth), a._lazyRace = !0, P++ , _(a, b, f, e, c)) } }, ba = C(function () { d.loadMode = 3, V() }), ca = function () { 3 == d.loadMode && (d.loadMode = 2), ba() }, da = function () { if (!l) { if (f.now() - p < 999) return void k(da, 999); l = !0, d.loadMode = 3, V(), j("scroll", ca, !0) } }; return { _: function () { p = f.now(), c.elements = b.getElementsByClassName(d.lazyClass), g = b.getElementsByClassName(d.lazyClass + " " + d.preloadClass), j("scroll", V, !0), j("resize", V, !0), a.MutationObserver ? new MutationObserver(V).observe(e, { childList: !0, subtree: !0, attributes: !0 }) : (e[h]("DOMNodeInserted", V, !0), e[h]("DOMAttrModified", V, !0), setInterval(V, 999)), j("hashchange", V, !0), ["focus", "mouseover", "click", "load", "transitionend", "animationend", "webkitAnimationEnd"].forEach(function (a) { b[h](a, V, !0) }), /d$|^c/.test(b.readyState) ? da() : (j("load", da), b[h]("DOMContentLoaded", V), k(da, 2e4)), c.elements.length ? (U(), z._lsFlush()) : V() }, checkElems: V, unveil: aa, _aLSL: ca } }(), E = function () { var a, c = A(function (a, b, c, d) { var e, f, g; if (a._lazysizesWidth = d, d += "px", a.setAttribute("sizes", d), n.test(b.nodeName || "")) for (e = b.getElementsByTagName("source"), f = 0, g = e.length; f < g; f++)e[f].setAttribute("sizes", d); c.detail.dataAttr || w(a, c.detail) }), e = function (a, b, d) { var e, f = a.parentNode; f && (d = y(a, f, d), e = v(a, "lazybeforesizes", { width: d, dataAttr: !!b }), e.defaultPrevented || (d = e.detail.width) && d !== a._lazysizesWidth && c(a, f, e, d)) }, f = function () { var b, c = a.length; if (c) for (b = 0; b < c; b++)e(a[b]) }, g = C(f); return { _: function () { a = b.getElementsByClassName(d.autosizesClass), j("resize", g) }, checkElems: g, updateElem: e } }(), F = function () { F.i || (F.i = !0, E._(), D._()) }; return c = { cfg: d, autoSizer: E, loader: D, init: F, uP: w, aC: s, rC: t, hC: r, fire: v, gW: y, rAF: z } } });
    /*! ls.rias.min.ks - v4.1.8 */
    !function (a, b) { var c = function () { b(a.lazySizes), a.removeEventListener("lazyunveilread", c, !0) }; b = b.bind(null, a, a.document), "object" == typeof module && module.exports ? b(require("lazysizes")) : a.lazySizes ? c() : a.addEventListener("lazyunveilread", c, !0) }(window, function (a, b, c) { "use strict"; function d(b, c) { var d, e, f, g, h = a.getComputedStyle(b); e = b.parentNode, g = { isPicture: !(!e || !m.test(e.nodeName || "")) }, f = function (a, c) { var d = b.getAttribute("data-" + a); if (!d) { var e = h.getPropertyValue("--ls-" + a); e && (d = e.trim()) } if (d) { if ("true" == d) d = !0; else if ("false" == d) d = !1; else if (l.test(d)) d = parseFloat(d); else if ("function" == typeof j[a]) d = j[a](b, d); else if (q.test(d)) try { d = JSON.parse(d) } catch (a) { } g[a] = d } else a in j && "function" != typeof j[a] ? g[a] = j[a] : c && "function" == typeof j[a] && (g[a] = j[a](b, d)) }; for (d in j) f(d); return c.replace(p, function (a, b) { b in g || f(b, !0) }), g } function e(a, b) { var c = [], d = function (a, c) { return k[typeof b[c]] ? b[c] : a }; return c.srcset = [], b.absUrl && (s.setAttribute("href", a), a = s.href), a = ((b.prefix || "") + a + (b.postfix || "")).replace(p, d), b.widths.forEach(function (d) { var e = b.widthmap[d] || d, f = b.aspectratio || b.ratio, g = !b.aspectratio && j.traditionalRatio, h = { u: a.replace(n, e).replace(o, f ? g ? Math.round(d * f) : Math.round(d / f) : ""), w: d }; c.push(h), c.srcset.push(h.c = h.u + " " + d + "w") }), c } function f(a, c, d) { var f = 0, g = 0, h = d; if (a) { if ("container" === c.ratio) { for (f = h.scrollWidth, g = h.scrollHeight; !(f && g || h === b);)h = h.parentNode, f = h.scrollWidth, g = h.scrollHeight; f && g && (c.ratio = g / f) } a = e(a, c), a.isPicture = c.isPicture, u && "IMG" == d.nodeName.toUpperCase() ? d.removeAttribute(i.srcsetAttr) : d.setAttribute(i.srcsetAttr, a.srcset.join(", ")), Object.defineProperty(d, "_lazyrias", { value: a, writable: !0 }) } } function g(a, b) { var e = d(a, b); return j.modifyOptions.call(a, { target: a, details: e, detail: e }), c.fire(a, "lazyriasmodifyoptions", e), e } function h(a) { return a.getAttribute(a.getAttribute("data-srcattr") || j.srcAttr) || a.getAttribute(i.srcsetAttr) || a.getAttribute(i.srcAttr) || a.getAttribute("data-pfsrcset") || "" } var i, j, k = { string: 1, number: 1 }, l = /^\-*\+*\d+\.*\d*$/, m = /^picture$/i, n = /\s*\{\s*width\s*\}\s*/i, o = /\s*\{\s*height\s*\}\s*/i, p = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi, q = /^\[.*\]|\{.*\}$/, r = /^(?:auto|\d+(px)?)$/, s = b.createElement("a"), t = b.createElement("img"), u = "srcset" in t && !("sizes" in t), v = !!a.HTMLPictureElement && !u; !function () { var b, d = function () { }, e = { prefix: "", postfix: "", srcAttr: "data-src", absUrl: !1, modifyOptions: d, widthmap: {}, ratio: !1, traditionalRatio: !1, aspectratio: !1 }; i = c && c.cfg || a.lazySizesConfig, i || (i = {}, a.lazySizesConfig = i), i.supportsType || (i.supportsType = function (a) { return !a }), i.rias || (i.rias = {}), "widths" in (j = i.rias) || (j.widths = [], function (a) { for (var b, c = 0; !b || b < 3e3;)c += 5, c > 30 && (c += 1), b = 36 * c, a.push(b) }(j.widths)); for (b in e) b in j || (j[b] = e[b]) }(), addEventListener("lazybeforesizes", function (a) { if (a.detail.instance == c) { var b, d, e, k, l, m, o, p, q, s, t, u, x; if (b = a.target, a.detail.dataAttr && !a.defaultPrevented && !j.disabled && (q = b.getAttribute(i.sizesAttr) || b.getAttribute("sizes")) && r.test(q)) { if (d = h(b), e = g(b, d), t = n.test(e.prefix) || n.test(e.postfix), e.isPicture && (k = b.parentNode)) for (l = k.getElementsByTagName("source"), m = 0, o = l.length; m < o; m++)(t || n.test(p = h(l[m]))) && (f(p, e, l[m]), u = !0); t || n.test(d) ? (f(d, e, b), u = !0) : u && (x = [], x.srcset = [], x.isPicture = !0, Object.defineProperty(b, "_lazyrias", { value: x, writable: !0 })), u && (v ? b.removeAttribute(i.srcAttr) : "auto" != q && (s = { width: parseInt(q, 10) }, w({ target: b, detail: s }))) } } }, !0); var w = function () { var d = function (a, b) { return a.w - b.w }, e = function (a) { var b, c, d = a.length, e = a[d - 1], f = 0; for (f; f < d; f++)if (e = a[f], e.d = e.w / a.w, e.d >= a.d) { !e.cached && (b = a[f - 1]) && b.d > a.d - .13 * Math.pow(a.d, 2.2) && (c = Math.pow(b.d - .6, 1.6), b.cached && (b.d += .15 * c), b.d + (e.d - a.d) * c > a.d && (e = b)); break } return e }, f = function (a, b) { var d; return !a._lazyrias && c.pWS && (d = c.pWS(a.getAttribute(i.srcsetAttr || ""))).length && (Object.defineProperty(a, "_lazyrias", { value: d, writable: !0 }), b && a.parentNode && (d.isPicture = "PICTURE" == a.parentNode.nodeName.toUpperCase())), a._lazyrias }, g = function (b) { var d = a.devicePixelRatio || 1, e = c.getX && c.getX(b); return Math.min(e || d, 2.4, d) }, h = function (b, c) { var h, i, j, k, l, m; if (l = b._lazyrias, l.isPicture && a.matchMedia) for (i = 0, h = b.parentNode.getElementsByTagName("source"), j = h.length; i < j; i++)if (f(h[i]) && !h[i].getAttribute("type") && (!(k = h[i].getAttribute("media")) || (matchMedia(k) || {}).matches)) { l = h[i]._lazyrias; break } return (!l.w || l.w < c) && (l.w = c, l.d = g(b), m = e(l.sort(d))), m }, j = function (d) { if (d.detail.instance == c) { var e, g = d.target; if (!u && (a.respimage || a.picturefill || lazySizesConfig.pf)) return void b.removeEventListener("lazybeforesizes", j); ("_lazyrias" in g || d.detail.dataAttr && f(g, !0)) && (e = h(g, d.detail.width)) && e.u && g._lazyrias.cur != e.u && (g._lazyrias.cur = e.u, e.cached = !0, c.rAF(function () { g.setAttribute(i.srcAttr, e.u), g.setAttribute("src", e.u) })) } }; return v ? j = function () { } : addEventListener("lazybeforesizes", j), j }() });
}

// Fix the confict suggestion search in Debut theme
if (typeof theme !== 'undefined' && theme.hasOwnProperty('settings')) theme.settings.predictiveSearchEnabled = false;
// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSThemeConfig.custom.products_per_page,
		/* Optional */
		loadProductFirst: false,
		// Placeholder  
		showPlaceholderProductList: true,
		placeholderProductPerRow: 3,
		placeholderProductGridItemClass: 'boost-pfs-filter-product-item boost-pfs-filter-product-item-grid boost-pfs-filter-grid-width-3 boost-pfs-filter-grid-width-mb-2',
		enableOTP: true,
		separateRefineByFromFilter: true,
		filterTreeMobileStyle: 'style2', // 'style2', 'style3',
		equal_height: boostPFSThemeConfig.custom.equal_height,
		cropImagePossitionEqualHeight: boostPFSThemeConfig.custom.equal_height_crop_image_position,
		defaultDisplay: boostPFSThemeConfig.custom.product_item_type,
        enableAjaxCart: false,
		ajaxCartStyle: 'slide', // 'slide' or 'popup'
		showAjaxCartOnAdd: true, // Opens the ajax cart after add to cart
		autoCloseMiniCart: false, // Auto close the cart after add to cart > open cart > close cart
		autoCloseMiniCartDuration: 2000,
		selectOptionInProductItem: true, // Append the product's option inside the product item when clicking "select option"
		selectOptionContainer: '.boost-pfs-filter-product-item-image',  // CSS selector to append the product option, if left empty it will append to the product item
    },
	selector: {
		otpButtons: '.boost-pfs-filter-product-item-image'
	},
    boostProductOptionSwatch: {
        color: {
            swatchName: 'Color',
            optionName: 'color',
            swatchDisplay: boostPFSThemeConfig.custom.display_item_swatch,
            swatchType: boostPFSThemeConfig.custom.swatch_color_display_type
        },
        size: {
            swatchName: 'Size',
            optionName: 'size',
            swatchDisplay: boostPFSThemeConfig.custom.display_item_swatch_size,
            swatchType: ''
        }
    }
};

(function() {
	var onSale = false,
		soldOut = false,
		priceVaries = false,
		images = [],
		firstVariant = {},
        colorCount=0,
		boostPFSImgDefaultSrc = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
		boostPFSRangeWidths = [180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048];

	BoostPFS.inject(this);

	/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	function prepareShopifyData(data) {
		// Displaying price base on the policy of Shopify, have to multiple by 100
		soldOut = !data.available; // Check a product is out of stock
		onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Convert images to array
		


		images = data.images_info;
		// Get First Variant (selected_or_first_available_variant)
		firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		return data;
	}

	/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	/************************** BUILD PRODUCT LIST **************************/
	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;
		// Customize API data to get the Shopify data
		data = prepareShopifyData(data);


		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;

        /* Start-Boost-163041 */
        var itemProductInfoHtml = '';
        var tags = data.tags.join(',');
        if (tags.indexOf('NonProductCard') == -1) {
			itemProductInfoHtml +='<div class="colorSwatch">'+'{{itemColorSwatches}}'+'</div>'+
			'<div class="boost-pfs-filter-product-bottom">' +
                                        '<div class="boost-pfs-filter-product-bottom-inner product-content">' +
                                            '<a href="{{itemUrl}}" class="a boost-pfs-filter-product-item-title">{{itemTitle}}</a>' +
                                            '{{itemReviews}}' +
                                            '{{itemPrice}}' +
                                            '{{itemIcon}}' +
                                            //'{{itemColorCount}}' +
                            				'{{itemSizeSwatches}}' +
                                        '</div>' +
                                    '</div>';
        }
		itemHtml = itemHtml.replace(/{{itemProductInfo}}/g, itemProductInfoHtml);
        /* End-Boost-163041 */
      
		// Add Custom class
		var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		var saleClass = onSale ? boostPFSTemplate.saleClass : '';
		var NonProduct = '';

		if(data.tags.includes('NonProductCard')){
			NonProduct = 'NonProduct';
		}

		itemHtml = itemHtml.replace(/{{NonProduct}}/g, NonProduct);

		itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
		itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
		// Add custom tag label 
        var customTagHtml = "";
        //if(data.tags.includes("onlyweb-MEMN")) customTagHtml = `<span style="padding: 5px; color: white; background: black; border-radius: 5px">Web only</span>`;
        itemHtml = itemHtml.replace(/{{customTagLabel}}/g, customTagHtml);
		// Add Grid Width class
		itemHtml = itemHtml.replace(/{{gridWidthClass}}/g, buildGridWidthClass(data));
		// Add Label
		// itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
        /* Start-Boost-163041 */
		itemHtml = itemHtml.replace(/{{itemLabels}}/g, tags.indexOf('NonProductCard') != -1 ? '' : buildLabels(data, data.variants[0].id));
        /* End-Boost-163041 */
		// Add TAG Label
        /* Start-Boost-163041 */
		itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, tags.indexOf('NonProductCard') != -1 ? '' : buildTagLabels(data, false));
        /* End-Boost-163041 */
		// Add Images
		itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
		// Add Price
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));
		// Add Review
		if (typeof Integration === 'undefined' ||
			(typeof Integration != 'undefined' &&
				typeof Integration.hascompileTemplate == 'function' &&
				!Integration.hascompileTemplate('reviews'))) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
		}

      	// Add Icon
      	var itemIconOne = '';
      	var itemIconTwo = '';
      	var itemIconThree = '';
      	var itemIconFour = '';
      	var itemIconFive = '';
      	var itemIconSix = '';
      	var itemIcon = '';

        if(data.tags.indexOf('iconfairtrade') !== -1) {
          itemIconOne = '<div class="icon"><svg viewBox="0 0 32 32" id="icon--ser--fairtrade" xmlns="http://www.w3.org/2000/svg"><title>Fair Trade</title><g id="mdicons-/-SER-/-Fairtrade" stroke="none" stroke-width="1" fill-rule="evenodd"><path d="M15.537 7.722c5.259 0 9.537 3.556 9.537 7.928a6.74 6.74 0 01-.828 3.21c.572.908.742 1.66.742 1.66.12.51.18 1.039.18 1.573 0 4.828-4.325 8.907-9.446 8.907-5.121 0-9.447-4.079-9.447-8.907 0-1.092.36-2.042.798-2.8C6.372 18.175 6 16.937 6 15.65c0-4.372 4.279-7.928 9.537-7.928zm5.421 6.096l-.035.01c-.062.03-.101.152-.115.232l-.845 3.496c-.012.06.01.08.042.09 0 0-3.745-1.392-8.663.001.034-.012.055-.03.044-.09l-.844-3.497c-.015-.08-.054-.203-.116-.232-.062-.029-.107.005-.206.065l-.136.098c-1.386 1.135-1.545 2.56-1.414 3.705.057.378.174 1.033.3 1.34-.358.382-.68.84-.9 1.385l-.01-.003-.074.28c-.12.446-.18.915-.18 1.395 0 3.998 3.625 7.375 7.916 7.375 4.29 0 7.916-3.377 7.916-7.375 0-.562-.083-1.09-.25-1.614l-.02-.06a4.576 4.576 0 00-.988-1.464c.127-.413.237-.832.302-1.257.128-1.147-.031-2.572-1.417-3.707l-.136-.098c-.099-.06-.144-.094-.206-.065zm-5.365 6.037c2.285 0 4.43.623 5.64 1.5-.286.386-.809.73-1.543 1-1.085.4-2.545.62-4.11.62-1.567 0-3.027-.22-4.112-.62-.71-.263-1.223-.593-1.514-.964 1.166-.902 3.304-1.536 5.639-1.536zm.047-1.739c1.565 0 3.025.24 4.11.676 1.101.442 1.724 1.06 1.783 1.75-1.462-.964-3.751-1.513-5.94-1.513-2.151 0-4.4.544-5.845 1.5.066-.684.688-1.298 1.781-1.737 1.086-.436 2.546-.676 4.11-.676zM15.568 1a2.83 2.83 0 012.827 2.828 2.83 2.83 0 01-2.827 2.828 2.831 2.831 0 01-2.828-2.828A2.832 2.832 0 0115.568 1z" id="mdCombined-Shape"></path></g></svg></div>';
        } 
        if(data.tags.indexOf('iconrecycled') !== -1) {
          itemIconTwo = '<div class="icon"><svg viewBox="0 0 32 32" id="icon--ser--recycled" xmlns="http://www.w3.org/2000/svg"><title>Recycled</title><g id="mhicons-/-black-/-SER-/-Recycled" stroke="none" stroke-width="1" fill-rule="evenodd"><path d="M26.4 15.916a.698.698 0 01.854.343l.933 1.836a5.889 5.889 0 01.077 5.526.677.677 0 01-.049.104l-.148.251c-1.107 1.832-3.034 2.92-5.166 2.865l-2.796-.027-.042 2.499a.698.698 0 01-1.155.516l-6.122-5.301a.698.698 0 01.035-1.085l6.237-4.733a.699.699 0 011.121.56l-.012 2.27 2.813.028a.593.593 0 00.557-.293.619.619 0 00.022-.652h.002l-1.024-1.766a2.768 2.768 0 01-.077-.129l-.103-.198a.83.83 0 01-.135-.79c.059-.166.2-.395.537-.538.058-.025.236-.1 3.54-1.251zm-7.625 4.764l-4.423 3.356 4.339 3.757.028-1.697a.7.7 0 01.698-.687h.008l3.495.035a4.487 4.487 0 003.947-2.185l.106-.178a.47.47 0 01.025-.053c.04-.077.07-.158.106-.237a2.513 2.513 0 01-.79.137l-3.62.045a.739.739 0 01-.132-.011l-3.104-.032a.698.698 0 01-.691-.702l.008-1.548zm-7.73-10.62a.7.7 0 01.935.551l1.155 7.745a.7.7 0 01-1.03.713l-1.985-1.1-.719 1.28-.006.016-.658 1.171a.613.613 0 00-.004.615c.13.224.321.333.56.333l1.621-.078c.08-.004.111-.005.144-.005l.222.005a.94.94 0 01.135-.01.83.83 0 01.622.27c.118.132.252.365.215.73-.016.162-.167 1.042-.555 3.246l-.09.514a.698.698 0 01-.681.583l-1.608.018a5.904 5.904 0 01-4.914-2.588.696.696 0 01-.067-.092l-.149-.25a5.863 5.863 0 01-.031-5.907l1.368-2.44-2.172-1.237a.7.7 0 01.102-1.262zm-3.25 12.057l-.665 1.184c-.127.235-.463 1.058.614 1.677l.01.007a4.55 4.55 0 001.549.275l1.027-.012c.105-.598.32-1.813.442-2.535l-1.443.068a2.04 2.04 0 01-1.535-.664zm2.93-10.447l-5.38 1.999 1.475.84c.334.19.452.614.263.95l-1.71 3.048a4.478 4.478 0 00.02 4.512l.106.179c.013.015.025.03.035.046.031.048.07.09.102.136.056-.288.155-.552.278-.767l1.6-2.853c.005-.009.008-.017.014-.026l1.714-3.055a.699.699 0 01.948-.27l1.353.752-.818-5.491zm15.56 5.766c-1.3.453-2.036.713-2.451.86l.943 1.642c.28.512.33 1.085.16 1.61l1.367-.018c.266-.006 1.123-.127 1.147-1.321a4.558 4.558 0 00-.517-1.496zM15.945 3l.29.003c2.141.052 4.027 1.195 5.054 3.06l1.365 2.441 2.19-1.206a.699.699 0 011.022.747l-1.558 7.946a.698.698 0 01-.96.509l-7.206-3.061a.698.698 0 01-.07-1.252l1.974-1.118-1.372-2.454a.615.615 0 00-.532-.338.609.609 0 00-.575.302l-.914 1.6a2.341 2.341 0 01-.069.124l-.12.188a.971.971 0 01-.063.12.825.825 0 01-.555.388c-.175.033-.443.025-.735-.197a318.91 318.91 0 01-2.966-2.436.699.699 0 01-.128-.906l1.052-1.632a5.941 5.941 0 011.308-1.488.693.693 0 01.225-.201c.042-.023.082-.04.123-.06a5.861 5.861 0 013.106-1.07.684.684 0 01.113-.009zM16 4.398a.548.548 0 01-.057.005c-.058.002-.114.013-.171.017a2.5 2.5 0 01.476.6l1.772 3.124c.014.024.022.05.032.075l1.553 2.775a.698.698 0 01-.266.95l-1.348.762 5.11 2.17 1.105-5.632-1.487.82a.699.699 0 01-.947-.272l-1.706-3.05a4.477 4.477 0 00-3.857-2.34zm-.97 1.306c-.13-.22-.62-.876-1.606-.415-.46.341-.859.77-1.17 1.275-.001.005-.004.009-.007.013a.564.564 0 01-.033.047l-.689 1.072c.55.455 1.454 1.2 1.995 1.641l.842-1.467a2.011 2.011 0 011.357-.95z" id="mhCombined-Shape"></path></g></svg></div>';
        }     
	    if (data.tags.indexOf('iconorganic') !== -1) {
	        itemIconThree = '<div class="icon"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="organic" x="0px" y="0px" viewBox="0 0 700 700" xml:space="preserve"><title>Organic</title><path d="M332.1,644.1c-20.9-7.7-38.6-19.9-56.1-32.4c-43.3-31-80.1-68.3-108.6-113.5c-25.3-40.1-41.5-83.6-47.8-130.7  c-12.1-89.6,10.6-170,64.1-242c36-48.4,80.6-87.2,133.7-115.9c21.3-11.5,43.4-11.5,64.9-0.2c32.6,17,61.5,39.1,88.1,64.4  c37.3,35.5,67.6,76,87.7,123.7c15.1,35.7,24,72.8,25.4,111.7c2.9,80.9-21.4,153.3-70.5,217.2c-35.5,46.3-79.2,83.5-130.6,111.5  c-4.2,2.3-8.7,4-13.7,6.2c0,11.5,0.1,23.6,0,35.6c-0.1,10-5.8,17.3-14.6,19c-11.1,2.2-21.3-5.6-21.7-17c-0.4-10.7-0.1-21.4-0.2-32  C332.1,647.6,332.1,645.7,332.1,644.1z M369.2,453.6c39.9-72.6,95-127,177.7-148.9c-3.6-41.7-14.4-81.2-34.9-118.2  c-3.5,1.4-6.5,2.4-9.4,3.8c-4.3,2.1-8.7,4.2-12.7,6.7c-36.6,22.5-64.6,53.5-85.4,90.7C375.8,339.2,364.9,394.8,369.2,453.6z   M187.8,186.5c-20.1,37.3-31.5,76.7-34.7,118.8c40.2,8.6,74.1,28.7,104.6,55.1c30.5,26.4,54.6,58,73.4,95.2c0.4-2.2,0.6-2.9,0.6-3.6  c0-26.5-0.6-53-5.8-79.1c-12.9-63.9-42.5-118-93.3-159.7C219.2,202.3,204.9,192.8,187.8,186.5z M546.3,342.9  c-5.1,1.7-9.4,2.8-13.4,4.5c-63.7,26.6-108,73-136.5,135.2c-12.7,27.8-20.1,57.3-24.2,87.6c-1.5,10.6-1.9,21.4-3,33.2  c2.9-1.6,4.6-2.4,6.3-3.4c38.5-22.5,71.8-51.2,100.3-85.4c27.6-33.1,48.2-69.9,60.1-111.4C541.3,383.8,545.1,364.2,546.3,342.9z   M330,603.3c0-2.2,0.1-3.4,0-4.6c-1.6-31.4-6.8-62.2-17.2-91.9c-24.4-69.4-68.3-122-134.9-154.7c-7.5-3.7-15.6-6-23.9-9.2  c1.8,39.5,14.5,93.1,50.4,145.6C237.1,536.3,279.2,573.9,330,603.3z M331.4,43.1c-49.5,28.8-91.1,65.1-124.1,111.5  c55.2,26.7,94.4,69,124.1,123C331.4,198.6,331.4,121.4,331.4,43.1z M368.9,43.2c0,78,0,155,0,232.7c29.9-52.6,68.3-95.5,123.7-121.3  C459.7,108,418,72.1,368.9,43.2z"/></svg></div>';
	    } 
	    if (data.tags.indexOf('iconhemp') !== -1) {
	        itemIconFour = '<div class="icon"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="hemp" x="0px" y="0px" viewBox="0 0 700 700" style="enable-background:new 0 0 700 700;" xml:space="preserve"><path d="M438.9,389.6c1.3-1.2,2.1-1.8,2.8-2.5c58.8-58.6,129.9-95.4,209.3-117.4c6.1-1.7,12.1-4.2,18.9-2.8  c11.2,2.5,18.6,13.7,16.3,24.9c-12.1,61-39,114.6-80.3,160.9c-19.1,21.4-40.6,40.3-64.3,56.6c-1.2,0.8-2.3,1.7-4,3  c7.8,0.8,15,1.4,22.2,2.2c34.1,4.2,66.1,14.3,94.5,34.2c11.7,8.2,13.2,23.1,3.1,33.5c-9.7,10-21.5,17.3-33.8,23.4  c-29.8,14.8-61.2,24.2-94.1,28.8c-16.6,2.3-33.2,4-50,3.3c-36.1-1.3-70.5-9-102.4-26.6c-1-0.6-2.1-1.1-3.1-1.6  c-0.2-0.1-0.6-0.1-1.3-0.2c-0.1,1.5-0.2,3.1-0.2,4.6c0,21.3,0.1,42.6,0,63.8c0,10.5-6.6,18.8-16.2,20.8c-14,2.9-25.9-6.9-26-21.6  c-0.1-21.9,0-43.7,0-65.6c0-1.6,0-3.2,0-5.6c-3.1,1.8-5.7,3.3-8.4,4.8c-23.4,13.3-48.5,21.2-75.1,24.6c-62.7,8-121.9-4.1-177.8-32.9  c-9.9-5.1-18.9-12.3-27.2-19.8c-11.7-10.5-9.7-25.4,3.2-34.2c28.3-19.5,59.9-29.6,93.7-33.8c7.5-0.9,15.1-1.6,23.7-2.4  c-2.5-1.8-4.5-3.2-6.4-4.6c-32.5-23.2-60.9-50.6-84.5-82.8c-24.8-33.9-42.3-71.2-53-111.8c-1.8-6.6-3.3-13.4-4.6-20.1  c-3.3-16.8,10.2-29.8,26.9-25.4C109,285.3,172.1,314,227,359c9.9,8.1,19.1,16.9,28.5,25.5c1.7,1.6,2.9,3.7,4.3,5.5  c0.6-0.4,1.1-0.7,1.7-1.1c-1-4.8-1.9-9.7-3-14.5c-9.6-42.6-14.7-85.8-13.8-129.5c1.3-63.1,15.9-122.7,47.2-177.8  c11.9-21,25.9-40.5,41.7-58.8c8.8-10.2,25-9.7,33.7,0.6c25,29.5,45.6,61.8,60.4,97.6c11.1,26.8,18.5,54.6,23,83.2  c4.6,29.5,6.5,59.3,4.1,89c-2,25.5-5.7,50.9-9.2,76.3c-1.4,10.1-4.1,20-6.2,30.1C439.2,386.3,439.2,387.6,438.9,389.6z M349.8,534.2  c4.5-11.2,8.7-21.2,12.5-31.3c23.3-61,40.5-123.5,47.2-188.7c4.2-40.6,4.1-81.1-2.7-121.4c-7.7-45.9-23.5-88.5-49.6-127.2  c-2.2-3.3-4.6-6.6-7.5-10.7c-7.5,12-15,22.9-21.4,34.4c-24.7,44.5-36.8,92.6-40.4,143.1c-3.3,46.2,1.2,92,10.2,137.3  c8.1,40.9,19.9,80.7,34.3,119.8C337.8,504.2,343.7,518.6,349.8,534.2z M65.3,318.8c-0.5,0.3-0.9,0.6-1.4,0.9  c5.6,12.9,10.6,26,16.7,38.6c21,43.3,51.2,79,89.5,108.1c34.2,26,72.1,44.7,112.5,58.8c8.6,3,17.4,5.7,27.2,8.8  C259.2,425.6,176.7,355.8,65.3,318.8z M635.4,318.6c-112.1,37.2-194.5,106.9-244.9,214.5c1.8-0.2,2.5-0.2,3.2-0.4  c30.5-9.2,60.2-20.3,88.3-35.6c52.8-28.7,96.2-67.2,126.9-119.3C619.8,359.3,628.5,339.8,635.4,318.6z M298,575.2  c-1.3-0.5-2-0.8-2.6-1c-31.2-10-63-17.1-95.7-19.4c-24.4-1.8-48.6-1.3-72.6,3.7c-3.6,0.7-7.1,1.7-10.7,2.6c-3.7,1-7.3,2.1-10.9,3.4  c-3.3,1.2-6.5,2.6-10.3,4.1c25.4,11.9,51.2,19.5,78.2,23.6c31,4.7,61.6,4.1,92-3.9C276.5,585.4,287.2,581.2,298,575.2z M399.9,575.1  c2.2,1.2,3.4,2,4.6,2.6c23.5,11.6,48.7,16.7,74.7,17.6c36.2,1.2,71-6.1,104.9-18.4c6.3-2.3,12.4-5.2,19.1-8.1  c-19.3-8.5-46.6-14-68.7-14.7c-34.7-1.2-68.7,3.5-102.2,11.8C421.7,568.4,411.4,571.8,399.9,575.1z"/></svg></div>';
	    }
	    if (data.tags.indexOf('iconresponsiblewool') !== -1) {
	        itemIconFive = '<div class="icon"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Responsible_Wool" x="0px" y="0px" viewBox="0 0 700 700" style="enable-background:new 0 0 700 700;" xml:space="preserve"><title>Responsible Wool</title><g><path d="M461.3,254.2c16.2-1.5,30.6,3.3,44.5,10.3c3.4,1.7,6.8,3.6,10.1,5.5c9,5,11.5,15.2,5.4,23.5   c-10.4,14.3-23.3,25.5-40.5,30.9c-5.6,1.7-11.4,2.5-17.7,3.9c-1.3,7-2.5,14.6-4,22c-8.8,44.3-25.7,85.1-53.8,120.8   c-9.6,12.2-20.9,22.6-35.8,28.1c-16.2,6-31.4,3.5-45.9-5.1c-15.7-9.4-26.6-23.5-36.7-38.2c-19.4-28.4-31.3-60-39.1-93.3   c-2.5-10.7-4.3-21.5-6.2-32.3c-0.4-2.5-1.5-2.8-3.5-2.9c-9.7-0.3-19-2.3-27.8-6.6c-13.2-6.5-23.8-16-32-28   c-5.3-7.7-3.3-17.5,4.5-22.1c11.7-7,23.8-13.3,37.3-15.5c6.3-1,13-0.9,19.4-0.5c3.6,0.2,3.7-1.7,4.3-3.9   c5.9-20.7,18.2-35.8,38.2-44.4c9.6-4.1,19.8-6.4,30.2-6.9c17.9-0.9,35.8-2.1,53.7-1.4c14.9,0.5,29.9,2.3,44.5,5.5   c26.4,5.8,43.3,22.5,50.3,48.8C460.8,252.9,461,253.4,461.3,254.2z M341.1,235.9c-12.2,1.2-22.6,2.2-33,3.4   c-15.3,1.8-26.4,9.1-29.5,25.1c-1.6,7.8-3.4,16.1-2.5,23.8c1.6,14.2,13,23,28.5,23.2c6.7,0.1,11,3.2,13.6,8.7   c1.6,3.4,2.5,7.2,3.1,11c1.5,10.5-4.2,17.3-14.6,18.3c-1.3,0.1-2.6,0.2-3.8,0.3c-8.5,0.7-13.6,5.6-14.1,14.3c-0.2,3,0,6.2,0.9,9.1   c8.2,26.6,19.5,51.8,37.6,73.3c4.6,5.5,10.3,10.3,16.1,14.5c5.8,4.2,12.5,4.1,18.3-0.4c5.4-4.2,10.7-8.8,15.2-14   c16.1-19.1,26.8-41,34.2-64.7c1.7-5.3,3.3-10.8,3.6-16.4c0.6-9.5-5-15.1-14.5-15.7c-1.7-0.1-3.3-0.2-5-0.4   c-5.8-0.4-9.7-3.5-11.9-8.8c-5.2-12.8,3-27.3,16.5-29.3c0.9-0.1,1.8-0.2,2.7-0.4c13.5-2.1,23.1-10.6,25.3-23.3   c1.5-8.7-0.3-17.3-2.5-25.7c-2.9-10.7-9.8-17.6-20.7-19.9c-6.7-1.4-13.6-2.3-20.5-2.9C369.1,237.7,354.3,236.9,341.1,235.9z"/><path d="M600.4,378.5c0.3-9.1,1-18.1,0.9-27.2c-0.5-33.9-7.4-66.5-20.9-97.7c-15.4-35.6-37.9-66-67.2-91.4   c-32.5-28.1-69.9-46.7-111.9-55.6c-27.5-5.8-55.3-6.7-83.2-2.8c-56.9,7.9-105.4,32.5-145.8,73.2c-21.4,21.6-38.1,46.5-50.4,74.2   c-3.4,7.6-9,11.7-17.4,11.4c-11.9-0.5-19.3-12.9-14.4-24.4c7-16.5,15.8-32.2,26-47c29.3-42.6,67.3-75.2,114-97.4   c30.7-14.6,63-23.3,96.9-26c56.3-4.6,109.3,6.4,158.8,33.4c37.6,20.4,68.9,48.2,94.2,82.7c22.2,30.4,38.2,63.9,47.2,100.5   c7,28.4,10.1,57.2,8.2,86.4c-0.1,1.1,0,2.3,0,3.4c0.4,0.4,0.8,0.7,1.1,1.1c0.7-1.1,1.2-2.5,2.1-3.4c10.1-10.5,20.3-21,30.6-31.4   c8.1-8.1,18.9-7.7,25.9,0.5c4.9,5.8,5.4,14.5,1,20.7c-0.9,1.3-1.9,2.4-3,3.5c-21.1,21.7-42.3,43.2-63.1,65.1   c-8.4,8.8-19.6,8.5-27.9,0.1c-21.3-21.5-42.9-42.6-64.3-63.9c-10.1-10.1-6.6-25.8,6.7-29.8c6.8-2,12.6,0.3,17.5,5.1   c11.5,11.4,22.9,22.7,34.4,34.1c1,1,2,1.9,3,2.8C599.7,378.7,600.1,378.6,600.4,378.5z"/><path d="M64.6,389.9c-11,10.9-21.9,21.6-32.7,32.3c-5.2,5.2-11.1,7.7-18.4,5.6c-12.3-3.6-16.7-18.5-7.8-27.6   c21.8-22.4,43.9-44.5,66.1-66.5c7.4-7.3,17.4-7.4,24.8-0.3c22.4,21.3,44.6,42.7,66.8,64.1c6.9,6.7,7.6,15.5,2.4,22.6   c-5,6.8-14.5,9.1-22,5.1c-2-1.1-3.8-2.7-5.4-4.2c-12.3-11.6-24.5-23.3-36.7-35c-0.8-0.8-1.7-1.5-2.9-2.6   c4.6,33.8,14.9,65,32.4,93.7c36.8,60.4,90.1,98.6,158.5,115.7c24,6,48.6,7.8,73.2,6.1c56.8-3.8,107.2-23.8,150.5-61.2   c17-14.6,31.6-31.3,44.1-49.9c4.4-6.6,10.4-9.8,18.3-8.4c12.4,2.1,18.1,15.7,11,26.4c-16.8,25.1-36.9,47.1-60.6,65.9   c-26.9,21.3-56.7,37-89.3,47.6c-21.2,6.9-43,11.3-65.3,12.9c-21.8,1.6-43.5,1.4-65.1-1.8c-27.2-4-53.4-11.6-78.5-23   c-41.6-18.9-76.5-46.3-105-81.9c-26.4-33-44.2-70.2-53.7-111.4C67.4,406.1,66.2,398.1,64.6,389.9z"/></g></svg></div>';
	    }
	    if (data.tags.indexOf('icontraceabledown') !== -1) {
	        itemIconSix = '<div class="icon"><svg version="1.1" id="hemp" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 700 700" style="enable-background:new 0 0 700 700;" xml:space="preserve"><g><path d="M107.2,260.6c29.6,27.6,59.1,55.4,89.2,82.5c17.5,15.7,28.7,34.5,32.8,57.5c3.1,17.8,8.7,34.3,20.1,48.8 c21.5,27.1,47.4,49.1,77.1,66.2c25.7,14.8,52.7,27.3,79.2,40.8c1.2,0.6,2.4,1,3.7,1.2c7.4,1.7,12.9-2.3,13-9.9 c0.1-5.9,0-11.9-0.9-17.6c-3.7-22.3-7.3-44.7-11.8-66.9c-2.9-14.2-0.5-26.8,8.1-38.2c5.6-7.4,11.1-14.9,17.2-21.9 c13.8-15.6,29.7-28.7,47.5-39.6c5-3,9.7-6.8,13.7-11c11.5-11.8,16.9-27,21.7-42.2c8.5-27.4,9.1-55.4,6.5-83.7 c-1-10.4-8.3-14.2-17-8.7c-15.4,9.7-30.8,19.4-45.9,29.6c-29,19.7-57.8,39.8-86.7,59.7c-5.6,3.8-11.2,7.5-17.3,11.5 c-1.7-3.8-3.3-7.1-4.6-10.5c-7.1-19.1-10.4-38.9-9.5-59.3c0.5-11.8-2.2-22.5-8.3-32.6c-10.2-16.9-23.7-30.6-39.9-41.7 c-6.9-4.7-14-9.2-21.3-13.4c-8.1-4.7-14.9-1.1-16.1,8.2c-0.3,1.9-0.2,3.9-0.2,5.9c-0.3,55.6-0.5,111.2-0.8,166.8c0,1.5,0,3.1,0,4.6 c-0.4,0.3-0.9,0.6-1.3,0.9c-6.6-5.9-13.4-11.6-19.7-17.9c-17-16.8-31.6-35.7-45.9-54.8c-7-9.4-16.3-14.5-27.7-16.1 c-7.5-1.1-15.1-2-22.5-3.6c-13.9-3.1-26.8-9-39.6-14.9c-2.2-1-5.1-0.7-7.6-0.9c0.8,2.6,0.8,5.7,2.4,7.7 C98.6,251.7,102.7,256.4,107.2,260.6z M290.1,214.3c10.6,11.5,21.1,22,20.5,38.7c-0.7,21.9,4.3,42.9,11.1,63.5 c2.2,6.7,5.1,13.2,7.8,20.2c-13,6.6-23.6,18-39.4,21.2C290.1,309.8,290.1,262.5,290.1,214.3z M275.5,390.4c3.3,0.6,6.7,1.3,9.9,2.3 c10.6,3.2,20.8,1.8,29.9-3.7c17.9-10.7,35.6-21.6,52.9-33.2c26.3-17.6,52.2-36,78.3-53.9c11.6-7.9,23.3-15.6,34.9-23.4 c1.2-0.8,2.4-1.5,4-2.4c-2.4,16.3-6,31.9-14.3,45.7c-3.8,6.2-10.1,11.5-16.3,15.5c-13.9,9-26,19.9-37.5,31.6 c-16.5,16.9-31.7,34.9-42.2,56.4c-1.7,3.4-3,7-4.3,10.5c-2.1,5.7-2.1,11.4-0.6,17.4c3.7,14.6,7,29.3,10.5,43.9 c0.2,0.9,0.3,1.8,0.5,3.5c-7.5-2.5-14.6-4.5-21.4-7.2c-36-14.3-64-38.4-85-70.7c-5.9-9-7.7-19.7-10.2-30c-0.3-1.1-0.5-2.3-0.9-4.2 C267.9,389.1,271.7,389.7,275.5,390.4z"/> <path d="M694,345.3c-0.9-6.7-4.6-11.5-10.9-13.8c-6.7-2.5-13-1.2-18.1,3.9c-11.4,11.4-22.6,23-33.9,34.5c-1,1-1.3,2.6-2,3.9 c-0.4-0.5-0.7-0.9-1.1-1.4c0-10.8,0.3-21.7-0.1-32.5c-0.7-21.4-3.6-42.5-9.4-63.2c-16.4-58.9-48.1-107.9-96.1-145.8 c-63.9-50.4-136.8-69.4-217.2-57.6c-45.5,6.7-86.7,24.4-123.7,51.8c-17.6,13-33.3,28-47.5,44.6c-4.8,5.5-6.1,11.9-3,18.6 c3,6.3,8,9.9,15.2,10.1c6.1,0.2,10.7-2.8,14.5-7.3c11.2-13.3,23.6-25.4,37.5-35.8c59.9-44.7,126.7-60.6,200-45.9 c57.2,11.4,104.2,40.8,141,86c36.6,44.9,54,96.9,55,154.7c0.1,6.7-0.5,13.4-0.8,21c-11.9-11.6-22.8-22.4-33.9-32.9 c-2.3-2.2-5.1-4.3-8-5.4c-7.8-2.8-15.9,0.3-20.1,7.2c-4.2,6.8-3,15.4,3.3,21.6c21.6,21.2,43.2,42.4,65,63.5 c7.8,7.6,17.7,7.5,25.5-0.2c4-4,7.9-8,11.9-12.1c17-17.3,33.9-34.7,50.9-52C692.2,356.5,694.9,351.6,694,345.3z"/> <path d="M554.9,483.9c-7.9,10.6-15.6,21.4-24.3,31.3c-22.4,25.4-49.4,44.9-80.3,58.7c-42.1,18.8-86.1,25.6-131.9,20 c-42.7-5.2-81.4-20.5-115.7-46.2c-47.7-35.8-78.9-82.9-93.1-141c-1.7-7.2-2.9-14.5-4.3-21.7c1.9,0.4,2.9,1.2,3.8,2.1 c10.8,10.5,21.4,21.2,32.3,31.6c9.7,9.2,23.8,6.5,28.4-5.4c3.1-7.8,0.4-14.2-5.3-19.9c-20.9-20.4-41.8-40.9-62.6-61.4 c-9.5-9.3-18.7-9.2-28,0.2c-14.4,14.7-28.8,29.4-43.2,44.1c-6.7,6.8-13.6,13.5-20,20.6c-8.9,9.8-4.5,24.5,8.3,28 c6.9,1.9,12.4-0.6,17.4-5.4c11.5-11.1,23.2-22,34.6-32.8c0.3,2,0.7,5.3,1.3,8.6c7.7,45.9,25.5,87.5,53.9,124.5 c28,36.5,62.8,64.8,104.6,84.2c31.3,14.5,64.2,23.2,98.7,25.2c32.7,1.9,64.8-1.1,96.4-10.1c30.1-8.6,57.9-22,83.6-39.9 c29.5-20.7,54.1-46.3,73.8-76.4c3.5-5.4,3.7-11.2,0.8-16.8C578.1,474.6,562.7,473.6,554.9,483.9z"/></g></svg></div>';}

        var icons = [itemIconOne, itemIconTwo, itemIconThree, itemIconFour, itemIconFive, itemIconSix]

        itemHtml = itemHtml.replace(/{{itemIcon}}/g, icons.join(''));
      
		// Add Vendor
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));

		// itemActiveSwapClass
		itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, buildActiveSwapClass(data));

		// Add Color Swatches
		itemHtml = itemHtml.replace(/{{itemColorSwatches}}/g, buildProductOptionSwatches(data, boostPFSFilterConfig.boostProductOptionSwatch.color.swatchName, boostPFSFilterConfig.boostProductOptionSwatch.color.optionName, boostPFSFilterConfig.boostProductOptionSwatch.color.swatchDisplay, boostPFSFilterConfig.boostProductOptionSwatch.color.swatchType ));

        // Add Size Swatch
        itemHtml = itemHtml.replace(/{{itemSizeSwatches}}/g, buildProductOptionSwatches(data, boostPFSFilterConfig.boostProductOptionSwatch.size.swatchName, boostPFSFilterConfig.boostProductOptionSwatch.size.optionName, boostPFSFilterConfig.boostProductOptionSwatch.size.swatchDisplay, boostPFSFilterConfig.boostProductOptionSwatch.size.swatchType ));

      	/* Add Color Count
      	var itemColorLabel = colorCount == 1 ? 'color' : 'colores';
      	var itemColorCount = '<p class="product-tile__stat">'+ colorCount + ' ' + itemColorLabel + '</p>';
      	itemHtml = itemHtml.replace(/{{itemColorCount}}/g, itemColorCount); */
   
		// Add 
      	// var itemDesHtml = data.tags.indexOf('NonProductCard') == 1 ? '<div class="pfs-des-custom">'+data.body_html+'</div>' : ''
      	// itemHtml = itemHtml.replace(/{{itemDesHtml}}/g, itemDesHtml);
      
		// Add main attribute (Always put at the end of this function)
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);

		var productUrl = Utils.buildProductItemUrl(data);
        if (data.handle == 'card-collection-gift-card') {
            productUrl = '/products/gift-card';
        }

        if (data.handle == 'card-collection-canamo') {
            productUrl = '/pages/cañamo-industrial';
        }

        if (data.handle == 'card-collection-fairtrade') {
            productUrl = '/pages/comercio-justo';
        }

        if (data.handle == 'card-collection-netplus') {
            productUrl = '/collections/netplus';
        }

        if (data.handle == 'card-collections-webspecials') {
            productUrl = '/collections/web-specials';
        }

        if (data.handle == 'card-test') {
            productUrl = '/pages/centro-de-ayuda';
        }

        if (data.handle == 'card-collection-garantia-de-hierro') {
            productUrl = '/pages/garantia-de-hierro';
        }
      
        if (data.handle == 'card-collection-snow') {
            productUrl = '/pages/snow';
        }

        if (data.handle == 'card-collection-better-than-new') {
            productUrl = '/products/better-than-new';
        }

        if (data.handle == 'card-collection-better-than-new') {
            productUrl = '/products/better-than-new';
        }

        if (data.handle == 'card-collection-netplus-dos') {
            productUrl = 'https://youtu.be/4LHMZmtpZdg';

            jQ(document).ready(function() {
            	jQ('[href="https://youtu.be/4LHMZmtpZdg"]').attr('target', '_blank');
            });
        }

        if (data.handle == 'card-collection-yulex') {
            productUrl = 'https://youtu.be/_6WVtLdXqDk';

            jQ(document).ready(function() {
            	jQ('[href="https://youtu.be/_6WVtLdXqDk"]').attr('target', '_blank');
            });
        }

        if (data.handle == 'card-collections-sale') {
            productUrl = '/collections/sale';
        }

        if (data.handle == 'card-collections-ddp') {
            productUrl = '/collections/dia-del-padre';
        }

        if (data.handle == 'card-collections-ddp20off') {
            productUrl = '/collections/regalos-con-descuentos-dia-del-padre';
        }

        if (data.handle == 'card-collections-ddp-cuotas') {
            productUrl = '/collections/dia-del-padre';
        }

        if (data.handle == 'card-collection-pfas') {
            productUrl = '/pages/libre-de-pfc';
        }

        if (data.handle == 'card-collection-h2no') {
            productUrl = '/pages/norma-de-desempeno-h2no';
        }

        if (data.handle == 'card-collection-snow-mujer') {
            productUrl = '/collections/ski-snow-mujer';
        }

        if (data.handle == 'card-collection-snow-hombre') {
            productUrl = '/collections/ski-snow-hombre';
        }

        if (data.handle == 'card-collection-equipamento-snow') {
            productUrl = '/collections/equipamiento-ski-y-snow';
        }

        if (data.handle == 'card-sale-0326') {
            productUrl = '/collections/sale';
        }

		if (data.handle == 'card-nt0925-equipamiento') {
            productUrl = '/collections/nueva-temporada-mochilas-y-equipamiento';
        }

		if (data.handle == 'card-nt0925-kids') {
            productUrl = '/collections/nueva-temporada-ninos-y-bebes';
        }

		if (data.handle == 'card-nt0925-hombre') {
            productUrl = '/collections/nueva-temporada-hombre';
        }

		if (data.handle == 'card-nt0925-mujer') {
            productUrl = '/collections/nueva-temporada-mujer';
        }

        if(data.handle == 'card-collection-gg25-el') {
        	productUrl = "/collections/regalos-para-el"
        }

        if(data.handle == 'card-collection-gg25-ella') {
        	productUrl = '/collections/regalos-para-ella'
        }

        if(data.handle == 'card-collection-gg25-kids') {
        	productUrl = '/collections/regalos-para-ninos-y-bebes'
        }

        if (data.handle == 'card-collection-gg25-todos') {
        	productUrl = '/collections/regalos-para-todos' 
        }

        if (data.handle == 'card-collection-gg25-menos-de') {
        	productUrl = '/collections/a-menos-de-99500'
        }

        if(data.handle == 'card-collection-capsula-argentina-1') {
        	productUrl = '/collections/capsula-argentina'
        }

        if(data.handle == 'card-collection-untracked') {
        	productUrl = '/products/campera-untracked-hombre'
        }

        if(data.handle == 'card-collection-stormstride-hombre') {
        	productUrl = '/products/campera-stormstride-hombre'
        }

        if(data.handle == 'card-collection-stormstride-mujer') {
        	productUrl = '/products/campera-stormstride-mujer'
        }

		itemHtml = itemHtml.replace(/{{itemUrl}}/g, productUrl);
		
		itemHtml = itemHtml.replace(/{{firstVariant}}/g, data.variants[0].id);

		if(tags.indexOf('NonProductCard') == -1) {
			let activeSwatch = $(itemHtml).find("[js-swatch-img].active").data("value");
			let sizeOption = null;
			let validSizeValues = [];
		
			if (data.options_with_values && data.options_with_values.length) {
				sizeOption = data.options_with_values.find(option => 
					!option.name.toLowerCase().includes('color')
				);
			}
		
			if (sizeOption && sizeOption.values) {
				validSizeValues = sizeOption.values.filter(value => {
					const variantTitle = `${activeSwatch} / ${value.title}`;
					const currentVariant = data.variants.find(item => item.title.includes(variantTitle));
					return currentVariant;
				});
			}
		
			const showVariantList = sizeOption && validSizeValues.length > 1;
		
			let atcBlock = `
			<div class='atc-block' js-atc-block>
				<div class='atc-btn ${showVariantList ? 'has-multiple-variant' : ''}' js-atc-btn data-product-id="${data.id}">
					<span class="atc-btn__text">Agregar ahora</span>
					<span class="atc-btn__mobile-plus" style="display: none;">+</span>
				</div>
			`;
		
			if (showVariantList) {
				atcBlock += "<ul class='variant-list'>";
			
				validSizeValues.forEach(value => {
					const variantTitle = `${activeSwatch} / ${value.title}`;
			
					const currentVariant = data.variants.find(
						item => item.title === variantTitle
					);
			
					const isAvailable = currentVariant && currentVariant.available;
			
					atcBlock += `
						<li class='variant-item ${isAvailable ? '' : 'disabled'} ${currentVariant ? '' : 'hide'}'
							data-product-id="${data.id}"
							data-value="${value.title}"
							js-variant-item>
							${value.title}
						</li>
					`;
				});
			
				atcBlock += "</ul>";
			}
		
			atcBlock += "</div>";
			itemHtml = itemHtml.replace(/{{itemAtcBlock}}/g, atcBlock);
		} else {
			itemHtml = itemHtml.replace(/{{itemAtcBlock}}/g, "");
		}

		return itemHtml;
	};
	// Build Product List Item
	ProductListItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;
		// Customize API data to get the Shopify data
		data = prepareShopifyData(data);

		// For List View
		// Get Template
		var itemHtml = boostPFSTemplate.productListItemHtml;

		// Add Custom class
		var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		var saleClass = onSale ? boostPFSTemplate.saleClass : '';

		itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
		itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
		// Add Label
		itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data,  data.variants[0].id));
		// Add TAG Label
		itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, buildTagLabels(data, false));
		// Add Images
		itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));

		// Add Review
		if (typeof Integration === 'undefined' ||
			(typeof Integration != 'undefined' &&
				typeof Integration.hascompileTemplate == 'function' &&
				!Integration.hascompileTemplate('reviews'))) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
		}

		// Add Vendor
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));

		// Add Price
		var itemPriceHtml = buildPrice(data, onSale, priceVaries);
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

		// Description
		var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
		itemDescription = (itemDescription.split(" ")).length > 35 ? itemDescription.split(" ").splice(0, 35).join(" ") + '...' : itemDescription.split(" ").splice(0, 35).join(" ");
		itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);

		// itemActiveSwapClass
		itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, buildActiveSwapClass(data));

		// Add Color Swatches
		itemHtml = itemHtml.replace(/{{itemColorSwatches}}/g, buildProductOptionSwatches(data, boostPFSFilterConfig.boostProductOptionSwatch.color.swatchName, boostPFSFilterConfig.boostProductOptionSwatch.color.optionName, boostPFSFilterConfig.boostProductOptionSwatch.color.swatchDisplay, boostPFSFilterConfig.boostProductOptionSwatch.color.swatchType ));

        // Add Size Swatch
        itemHtml = itemHtml.replace(/{{itemSizeSwatches}}/g, buildProductOptionSwatches(data, boostPFSFilterConfig.boostProductOptionSwatch.size.swatchName, boostPFSFilterConfig.boostProductOptionSwatch.size.optionName, boostPFSFilterConfig.boostProductOptionSwatch.size.swatchDisplay, boostPFSFilterConfig.boostProductOptionSwatch.size.swatchType ));

		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);

		return itemHtml;
		// End For List View
	};

	/************************** END BUILD PRODUCT LIST **************************/
	/************************** BUILD PRODUCT ITEM ELEMENTS **************************/
	function buildGridWidthClass() {
		var gridWidthClass = '';
		// On PC
		switch (boostPFSThemeConfig.custom.products_per_row) {
			case 2:
				gridWidthClass = 'boost-pfs-filter-grid-width-2';
				break;
			case 3:
				gridWidthClass = 'boost-pfs-filter-grid-width-3';
				break;
			case 5:
				gridWidthClass = 'boost-pfs-filter-grid-width-5';
				break;
			case 6:
				gridWidthClass = 'boost-pfs-filter-grid-width-6';
				break;
			default:
				gridWidthClass = 'boost-pfs-filter-grid-width-4';
				break;
		}
		// On Mobile
		switch (boostPFSThemeConfig.custom.products_per_row_mobile) {
			case 1:
				gridWidthClass += ' boost-pfs-filter-grid-width-mb-1';
				break;
			case 3:
				gridWidthClass += ' boost-pfs-filter-grid-width-mb-3';
				break;
			default:
				gridWidthClass += ' boost-pfs-filter-grid-width-mb-2';
				break;
		}
		return gridWidthClass;
	}

	function buildImages(data) {
		var html = '',
			aspectRatio = '',
			rangeWidths = boostPFSRangeWidths,
			paddingTop = 100;

		var dataSrcSet = '',
			dataWidths = '',
			dataSizes = 'auto',
			imgAlt = data.title,
			flipImageSrcSet = '';

        var imgVariant = firstVariant;
		
		var productImage = images.length > 0 ? images[0] : { id: 0, src: boostPFSConfig.general.no_image_url };
		
        if(boostPFSConfig.general.collection_handle === "web-specials") {
          for(var i = 0; i < data.variants.length; i++) {
			if(data.variants[i].available) {
				var variant = data.variants[i];
				if(variant.available) {
				  var productImage = variant.image;
				  imgVariant = variant;   
				  break;
				}
			}
          }

		var currentImage = images.find(image => image.src === productImage);
		if (currentImage) productImage = currentImage;
         
        }
		var activeSwapImage = !Utils.isMobile() &&
			boostPFSThemeConfig.custom.hasOwnProperty('active_image_swap') &&
			boostPFSThemeConfig.custom.active_image_swap == true;

      	
        var secondImage = '';

        if(images.length > 1) {
			secondImage =  images[0]['src']
			
          var imageBack = images.find(image => image.alt && image.alt.toLowerCase().includes('back') && image.alt.toLowerCase().includes(imgVariant.option_color.toLowerCase()) );
	
          if (!imageBack && productImage.alt) {
            var secondAlt = productImage.alt.toLowerCase().replace('front', 'back');  
            imageBack = images.find(image => image.alt && image.alt.toLowerCase() === secondAlt);
          }
          
		  if(imageBack) {
            secondImage = imageBack.src
          } else {
			secondImage = images[0]['src']
		  }
        }


		  for (var i = 0; i < rangeWidths.length; i++) {
			
				dataSrcSet += Utils.optimizeImage(productImage['src'], rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';
				dataWidths += rangeWidths[i];
			
  
			  if (activeSwapImage) {
				  flipImageSrcSet += Utils.optimizeImage(secondImage, rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';
			  }
  
			  if (i < rangeWidths.length - 1) {
				  dataSrcSet += ', ';
				  dataWidths += ', ';
  
				  if (activeSwapImage) {
					  flipImageSrcSet += ', ';
				  }
			  }
		  }
	  

		if (productImage.id > 0) {
			aspectRatio = productImage['width'] / productImage['height'];
			paddingTop = 1 / aspectRatio * 100;
      
            if (productImage.alt) {
              imgAlt = escape(productImage.alt);
            }
        } else {
          paddingTop = 100;
        }

         /* Start-Boost-163041 */
        var tags = data.tags.join(',');
      	html += '<a href="{{itemUrl}}" class="boost-pfs-filter-product-item-image-link" ';
		html += 'style="padding-top:' + paddingTop + '%;';
        if (tags.indexOf('NonProductCard') != -1) {
          html += ' background: transparent;">';
        } else {
          html += '">';
        }
        /* End-Boost-163041 */
			html += `<img class="boost-pfs-filter-product-item-main-image  ${data.tags.includes('NonProductCard') ? 'lazyload Image--lazyLoad' : ''}"` +
				'data-srcset="' + dataSrcSet + '" ' +
				'data-src="' + Utils.optimizeImage(productImage['src'], rangeWidths[2] + 'x') + '" ' +
				'data-widths="[' + dataWidths + ']" ' +
				'data-sizes="' + dataSizes + '" ' +
                // 'src="' + boostPFSImgDefaultSrc + '" ' +
				'src="' + Utils.optimizeImage(productImage['src'], rangeWidths[2] + 'x') + '" ' +
				'alt="' + imgAlt + '" ';
		
		if (activeSwapImage) {
			html += 'data-img-flip-src="' + Utils.optimizeImage(secondImage, rangeWidths[2] + 'x') + '" ' +
        			'data-img-flip-alt="' + escape(secondImage.alt || data.title) + '" ' +
					'data-img-flip-srcset="' + flipImageSrcSet + '" ';
		}
		html += '/>'
        html += data.tags.includes('NonProductCard') ? '<div class="pfs-des-custom">'+data.body_html+'</div>' : ''

        html += '</a>';

		return html;

	}

	function buildVendor(data) {
		var html = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('show_vendor') &&
			boostPFSThemeConfig.custom.show_vendor == true) {
			html = boostPFSTemplate.vendorHtml;
		}
		return html;
	}

	function buildPrice(data) {
		var html = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('show_price') &&
			boostPFSThemeConfig.custom.show_price) {
			html = '<p class="boost-pfs-filter-product-item-price">';

            var priceMin = firstVariant.price;
            var comparePriceMin = firstVariant.compare_at_price;
            var onSale = comparePriceMin > priceMin;
            var isWebSpecial = data.tags.some(t => t.toLowerCase() === 'web-specials');
            var variants = data.variants.filter(v => v.available);
            var saleVariant = variants.find(v => parseFloat(v.compare_at_price) > parseFloat(v.price));            

            if (boostPFSConfig.general.collection_handle === 'web-specials' && saleVariant) {              
              html += '<span class="boost-pfs-filter-product-item-sale-price aa"><span class="pricedetector">salews</span> ' + Utils.formatMoney(parseFloat(saleVariant.price)) + '</span>';
              html += '<s>' + Utils.formatMoney(parseFloat(saleVariant.compare_at_price)) + '</s> ';
            } else if (onSale) {
            	html += '<s>' + Utils.formatMoney(comparePriceMin) + '</s>';
              html += '<span class="boost-pfs-filter-product-item-sale-price bb"><span class="pricedetector">saleinicial</span> ' + Utils.formatMoney(priceMin) + '</span>';            } else if (priceVaries) {
               var variantData = data.variants
                .filter(function(e) {
                  return e.compare_at_price == null;
                })
                .sort(function(a, b) {
                    return a.price - b.price;
                });  

              var price = variantData[0] ?  variantData[0].price : variantData.price;
              if (price == data.price_max) {
                html += '<span class="boost-pfs-filter-product-item-price-min zz"><span class="pricedetector">zzz</span> ' + Utils.formatMoney(price) + '</span>';
              } else if (price == 0) {
              	html += '<span class="boost-pfs-filter-product-item-price-min vv"><span class="pricedetector">vvv</span> ' + Utils.formatMoney(data.price_max) + '</span>';
              } else {
                //html += '<span class="boost-pfs-filter-product-item-price-min"><span class="pricedetector">xxx</span> ' + Utils.formatMoney(price) + '</span>';
                html += '<span class="boost-pfs-filter-product-item-price-min yy"><span class="pricedetector">yyy</span> ' + Utils.formatMoney(data.price_max) + '</span>';
              }
            } else {
              html += '<span class="boost-pfs-filter-product-item-price-min uu"><span class="pricedetector">uuu</span> ' + Utils.formatMoney(priceMin) + '</span>';
            }
			html += '</p>';
		}
		return html;
	}

	/*function buildPrice(data) {
		var html = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('show_price') &&
			boostPFSThemeConfig.custom.show_price) {
			html = '<p class="boost-pfs-filter-product-item-price">';
			console.log("money regular price" , data.compare_at_price_min)
			if (onSale) {
				// html += '<span class="boost-pfs-filter-product-item-sale-price">' + Utils.formatMoney(data.price_min) + '</span>';
				html += '<span class="boost-pfs-filter-product-item-regular-price">fff ' +Utils.formatMoney(data.price_max) +'</span>'
				// html += '<span class="boost-pfs-filter-product-item-regular-price">' + Utils.formatMoney(data.compare_at_price_min) + '</span> ';
			 
// 				if (priceVaries) {
// 					html += '<span class="boost-pfs-filter-product-item-price-from-text">' + (boostPFSThemeConfig.label_basic.from) + ' ' + '</span>';
// 				}
// 				html += '<span class="boost-pfs-filter-product-item-regular-price">' + Utils.formatMoney(data.price_min) + '</span>';
// 			}
        	} else if (priceVaries) {
//                 html += '<span class="boost-pfs-filter-product-item-regular-price">' + Utils.formatMoney(data.price_min) + '</span>';
//                 html += ' - <span class="boost-pfs-filter-product-item-regular-price">' + Utils.formatMoney(data.price_max) + '</span>';



                var variantData = data.variants.filter(function(e) {
                  	return e.compare_at_price == null;
                });
                variantData = variantData.sort(function(a, b) {
                  	return a.price - b.price;
                });
              	if (variantData[0]['price'] <= data.price_max) {
                  html += '<span class="boost-pfs-filter-product-item-regular-price">ggg' + Utils.formatMoney(data.price_max) + '</span>';
                } else {
                  html += '<span class="boost-pfs-filter-product-item-regular-price">hhh' + Utils.formatMoney(variantData[0]['price']) + '</span>';
                  html += ' - <span class="boost-pfs-filter-product-item-regular-price">iii' + Utils.formatMoney(data.price_max) + '</span>';
                }
            } else {
              	html += '<span class="boost-pfs-filter-product-item-regular-price">jjj' + Utils.formatMoney(data.price_min) + '</span>';
            }
			html += '</p>';
		}
		return html;
	}*/

	function buildLabels(data, selectedVariantId) {

		// console.log("build labels function " ,data.title , {data})
		let onlyWebLabel =''
		let newColorLabel =''
		let redesignedLabel = ''
		
		// onlyweb label
		data.metafields.map((metafield) => {
			if(metafield.namespace == 'custom' &&  metafield.value.replace(/\s+/g, '').toLowerCase() === "onlyweb"   && selectedVariantId== metafield.id) {
				onlyWebLabel = '<span class="sale boost-pfs-filter-label web-badge onlyweb">Only Web</span>';
			}
		})
		// new color
		// data.metafields.map((metafield) => {
		// 	if(metafield.namespace == 'custom' && metafield.value=='New Color'  && selectedVariantId== metafield.id) {
		// 		newColorLabel = '<span class="sale boost-pfs-filter-label web-badge onlyweb">New Color</span>';
		// 	}
		// })

	
		data.metafields.map((metafield) => {
			if(metafield.namespace == 'custom' && metafield.value=='Redesigned'  && selectedVariantId== metafield.id) {
				redesignedLabel = '<span class="sale boost-pfs-filter-label web-badge onlyweb">Redesigned</span>';
			}
		})

		// Build Sold out label
		var soldOutLabel = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('show_sold_out_label') &&
			boostPFSThemeConfig.custom.show_sold_out_label && soldOut) {
			soldOutLabel = boostPFSTemplate.soldOutLabelHtml.replace(/{{style}}/g, '');
		}
		// Build Sale label
        var webSpecialTag = false
        data.tags.forEach(tag => {
			
          if(tag.toLowerCase() === "web-specials") {
			
            webSpecialTag = true;
          }
        })
        
        var firstVariantOnSale = firstVariant.compare_at_price > firstVariant.price; 
        if(boostPFSConfig.general.collection_handle === "web-specials") {
          var variants = data.variants;
          for(var i = 0; i < variants.length; i++) {
            var variant = variants[i];
            if(variant.compare_at_price > variant.price) {
              firstVariantOnSale = true;
              break;
            }
          }
        }
      	var saleLabel = '';
        var salePercent = '';
        if(!webSpecialTag && firstVariantOnSale) {
          if (boostPFSThemeConfig.custom.show_sale_label && firstVariantOnSale && !soldOut) {
            if (boostPFSThemeConfig.custom.show_sale_percent){
              salePercent = Math.round((firstVariant.compare_at_price - firstVariant.price) * 100 / firstVariant.compare_at_price);
            }
            saleLabel = boostPFSTemplate.saleLabelHtml.replace(/{{style}}/g, '');
            saleLabel = boostPFSTemplate.saleLabelHtml.replace(/{{salePercent}}/g, salePercent + '% OFF');
          }

        } else if (webSpecialTag && firstVariantOnSale) {
        	salePercent = Math.round((firstVariant.compare_at_price - firstVariant.price) * 100 / firstVariant.compare_at_price);
          //saleLabel = '<span class="zz sale boost-pfs-filter-label web-badge">Web Special</span>';
          //saleLabel = '<span class="zz sale boost-pfs-filter-label web-badge">Sale</span>';
          saleLabel = '<span class="zz sale boost-pfs-filter-label web-badge">'+ salePercent +'% OFF</span>';
        }
      	
      	var NuevosTag = false
        data.tags.forEach(tag => {
          if(tag === "Nuevos") {
            NuevosTag = true;
          }
        })


      	var newLabel = '';
        var date1 = new Date(data.published_at); 
        var date2 = new Date(); 
        // To calculate the time difference of two dates 
        var diffDataTime = date2.getTime() - date1.getTime(); 
        // To calculate the no. of days between two dates 
        var diffDataDays = diffDataTime / (1000 * 3600 * 24); 
        diffDataDays = Math.round(diffDataDays);
      
        // if(diffDataDays <= 30 && !firstVariantOnSale ) {
				// 	newLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, 'Nuevo');
        // }else{
        // 	newLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, 'wsnew');
        // }

					// Helper: check if within N days from start_date_badge
								// Helper: check if within N days from start_date_badge
				// Helper: check if within N days from start_date_badge
				const isWithinDays = (metafields, daysLimit = 60) => {
					const startDateMeta = metafields.find(m => m.key === 'start_date_badge' && m.id == selectedVariantId);
					
					if (!startDateMeta?.value?.trim()) return false;

					const startDate = new Date(startDateMeta.value);
					if (isNaN(startDate)) return false;

					const now = new Date();
					const diffMs = now.getTime() - startDate.getTime();
					const diffDays = Math.round(diffMs / (1000 * 60 * 60 * 24));

					return diffDays >= 0 && diffDays <= daysLimit;
			};

			// ✅ New Color badge (variant-level)
			const newColorField = data.metafields.find(
					m => m.namespace === 'custom' &&
							m.key === 'new_color' &&
							m.value?.trim().toLowerCase() === 'new color' &&
							m.id == selectedVariantId
			);

			if (newColorField && isWithinDays(data.metafields)) {
					newColorLabel = '<span class="sale boost-pfs-filter-label web-badge onlyweb">Nuevo Color</span>';
			} else {
					// Fallback "Nuevo" badge
					newLabel = boostPFSTemplate.tagLabelHtml.replace(
							/{{labelTag}}/g,
							isWithinDays(data.metafields) && !firstVariantOnSale ? 'Nuevo' : 'wsnew'
					);
			}

				
				
		// Build Labels
		// return soldOutLabel + saleLabel + newLabel + onlyWebLabel;
		return soldOutLabel + saleLabel + newLabel + onlyWebLabel + newColorLabel + redesignedLabel;
	}

	// BUILD LABEL PRODUCT WITH TAGS
	function buildTagLabels(data, showall) {
		if (boostPFSThemeConfig.custom.show_label_by_tag) {
			if (showall) {
				var tagLabel = '';
				if (data.tags) {
					for (var i = 0; i < data.tags.length; i++) {
						var tag = data.tags[i];
						if (tag.indexOf("pfs:label") !== -1) {
							var preTagLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('pfs:label-')[1]);
							tagLabel += preTagLabel;
						}
					}
				}
			} else {
				var tagLabel = '';
				if (data.tags) {
					for (var i = data.tags.length - 1; i >= 0; i--) {
						tag = data.tags[i];
						if (tag.indexOf("pfs:label") !== -1) {
							var preTagLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('pfs:label-')[1]);
							tagLabel += preTagLabel;
							break;
						}
					}
				}
			}
			return tagLabel;
		} else {
			return "";
		}
	}

	
	// Build Color Swatches
    function buildProductOptionSwatches(data, swatchName, optionName, swatchDisplay, swatchType) {
		 
      var swatchesProductOptionHtml = '',
          filterSwatchTitle = swatchName,
          optionName  = optionName,
          swatchArr = [],
          countSwatch = 0,
          swatchValues = [],
          swatchLimit = 9999999999;

      var dataImgSize = '360',
          bgSize = '50x',
          dataImgSrc = Utils.getFeaturedImage(data.images_info, dataImgSize + 'x'),
          swatchName = '#ffffff',
          bgImageSrc = '',
          viewMoreLabel = 'More ' + filterSwatchTitle;
      var swatchSettings = Settings.getSettingValue('swatch_settings');
      var newProduct = false;
      var newLabel = '';
      var date1 = new Date(data.published_at); 
      var date2 = new Date(); 
      // To calculate the time difference of two dates 
      var diffDataTime = date2.getTime() - date1.getTime(); 
      // To calculate the no. of days between two dates 
      var diffDataDays = diffDataTime / (1000 * 3600 * 24); 
      diffDataDays = Math.round(diffDataDays);	

	  function productIsWithinDays(dateValue, days = 60) {
		if (!dateValue) return false;

		const startDate = new Date(dateValue);
		const now = new Date();

		const diffMs = now.getTime() - startDate.getTime();
		const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

		return diffDays >= 0 && diffDays <= days;
	}


     // 🔥 CHECK ANY VARIANT HAS VALID start_date_badge
		if (data.metafields && data.metafields.length) {
		for (var i = 0; i < data.variants.length; i++) {
			var variant = data.variants[i];

			var variantMetafields = data.metafields.filter(function(m) {
			return Number(m.id) === Number(variant.id) &&
					m.key === 'start_date_badge' &&
					m.value;
			});

			if (
			variantMetafields.length &&
			productIsWithinDays(variantMetafields[0].value, 60)
			) {
			newProduct = true;
			break; // ✅ STOP once found
			}
		}
		}

	  var count = 0;
	  var isDesktop = window.innerWidth >= 768;
		var DESKTOP_SWATCH_LIMIT = 5;
		var MOBILE_SWATCH_LIMIT = 4;
		
		var CURRENT_SWATCH_LIMIT = isDesktop
			? DESKTOP_SWATCH_LIMIT
			: MOBILE_SWATCH_LIMIT;
		
		var hiddenSwatchCount = 0;

      
      // Get and sort all variant not sale
      var variantData = data.variants.filter(function(e) {
        return e.compare_at_price == null;
      });
      variantData = variantData.sort(function(a, b) {
        return a.price - b.price;
      });

      if (swatchDisplay) {
        if (typeof data.options_with_values != 'undefined' && data.options_with_values.length > 0) {
          swatchArr = data.options_with_values.filter(function(option) {
            return option.name == optionName;
          });
          if (swatchArr.length > 0) {
            countSwatch = swatchArr[0].values.length;

            if (swatchLimit > countSwatch) {
              swatchLimit = countSwatch;
            }
            swatchValues = swatchArr[0].values;

            swatchesProductOptionHtml += '<ul class="boost-pfs-filter-item-swatch boost-pfs-filter-item-swatch-' + optionName + ' ">';

            for (var sIndex = 0; sIndex < swatchLimit; sIndex++) {
               swatchName = swatchValues[sIndex].title;
				var hideSwatch = count >= CURRENT_SWATCH_LIMIT;
              var swatchVariant = data['variants'][sIndex];
				
              var sImageIndex = swatchValues[sIndex].image || '';
              if (sImageIndex != '') {
                dataImgSrc = Utils.optimizeImage(data.images[sImageIndex], dataImgSize + 'x') + ' ' + dataImgSize + 'w';
              }

              if (swatchType) {
                switch (swatchType) {
                  case 'swatch_color_display_type_image_color':
                    bgImageSrc = boostPFSAppConfig.general.file_url.replace(/\?/, Utils.slugify(filterSwatchTitle).replace(/\-/g, '_') + '-' + Utils.slugify(swatchName) + '.png?v=');
                    bgImageSrc = '';
                    break;
                  case 'swatch_color_display_type_image_product':
                    bgImageSrc = Utils.getFeaturedImage(data.images_info, bgSize);
                    if (sImageIndex != '') {
                      bgImageSrc = Utils.optimizeImage(data.images[sImageIndex], bgSize);
                    }
                    break;
                  default:
                    bgImageSrc = '';
                }
              }

              var priceMin = '';
              var comparedPriceMin = '';
              var webSpecialTag = false
              var onSale = false;

              data.tags.forEach(tag => {
                if(tag.toLowerCase() === "web-specials") {
                  webSpecialTag = true;
                }
              })
              var activeClass = count == 0 ? 'active' : '';
			  var is_available = false;
			  let variant = data.variants.find(variant => variant.available && variant.title.toLowerCase().includes(swatchName.toLowerCase()) )

			  let availVrs= data.variants.find(variant => variant.available)


			  
			  var onlyWebLabel = ''
			  var newColorLabel = ''
			  var redesignedLabel = ''
			  var variantIDMetaOnlyWeb = 0
			  var variantIDMetaNewColor =0
			  

			  data.metafields.map((metafield) => {
				if(metafield.namespace == 'custom' && metafield.value == "'Redesigned'") {
					redesignedLabel = '<span class="sale boost-pfs-filter-label web-badge onlyweb">Only Web</span>';
				}
			  })
			if(variant){
				// onlyweb
				data.metafields.map((metafield) => {
				if(metafield.namespace == 'custom' &&  metafield.value.replace(/\s+/g, '').toLowerCase() === "onlyweb"  && variant.id == metafield.id) {
					variantIDMetaOnlyWeb = metafield.id

					onlyWebLabel = '<span class="sale boost-pfs-filter-label web-badge onlyweb">Only Web</span>';
					}
				})
				// New Color 
				data.metafields.map((metafield) => {
					if(metafield.namespace == 'custom' && metafield.value == 'New Color' && variant.id == metafield.id) {
						variantIDMetaNewColor = metafield.id
						newColorLabel = '<span class="sale boost-pfs-filter-label web-badge onlyweb">Nuevo Color</span>';
					}
				})
			}
  
              if (variant) {
                priceMin = variant.price;
                comparedPriceMin = variant.compare_at_price;
                onSale = comparedPriceMin > priceMin;
				is_available = variant.available;
              }



              var imageFront = images.find(image => image.alt && image.alt.toLowerCase().includes('front') && image.alt.toLowerCase().includes(swatchName.toLowerCase()));
              if(imageFront) {
                dataImgSrc = Utils.optimizeImage(imageFront.src, dataImgSize + 'x') + ' ' + dataImgSize + 'w';
              }

              var dataBackImgSrc = '';
              var imageBack = images.find(image => image?.alt && image?.alt.toLowerCase().includes('back') && image?.alt.toLowerCase().includes(swatchName.toLowerCase()));
              if(imageBack) {
                dataBackImgSrc = Utils.optimizeImage(imageBack.src, dataImgSize + 'x') + ' ' + dataImgSize + 'w';
              }



              if (swatchSettings) {
                var swatchKeys = Object.keys(swatchSettings);
                var swatchSetting = '';
                if (Array.isArray(swatchKeys) && swatchKeys.length > 0) {
                  var swatchSettingKey = swatchKeys.find(key => swatchName.toLowerCase() === key.toLowerCase());
                  swatchSetting = swatchSettings[swatchSettingKey];

                }
              }

              if (swatchSetting) {
                switch (swatchSetting.type) {
                  case FilterOptionItemSwatch.SwatchType.ONE_COLOR:
                    if (swatchSetting.colorCodes.length > 0 && swatchSetting.colorCodes[0]) {
                      swatchName = swatchSetting.colorCodes[0];
                      bgImageSrc = '';
                    }
                    break;
                  case FilterOptionItemSwatch.SwatchType.IMAGE:
                    if (swatchSetting.imageUrl) {
                      bgImageSrc = swatchSetting.imageUrl;
                    }
                    break;
                }
              }

              var nosalePrice = variantData[0] ? variantData[0]['price'] : firstVariant.price;

              if(webSpecialTag && boostPFSConfig.general.collection_handle === "web-specials" 
              	|| boostPFSConfig.general.collection_handle === "mujeres-web-specials" 
              	|| boostPFSConfig.general.collection_handle === "hombres-web-specials" 
              	|| boostPFSConfig.general.collection_handle === "ninos-bebes-web-specials" 
              	|| boostPFSConfig.general.collection_handle === "regalos-con-descuentos" 
              	|| boostPFSConfig.general.collection_handle === "sale" 
              	|| boostPFSConfig.general.collection_handle === "sale-mujeres" 
              	|| boostPFSConfig.general.collection_handle === "sale-hombres" 
              	|| boostPFSConfig.general.collection_handle === "sale-ninos-bebes" 
              	|| boostPFSConfig.general.collection_handle === "sale-bolsos-accesorios" 
              	|| boostPFSConfig.general.collection_handle === "sale-50off"            	
              	|| boostPFSConfig.general.collection_handle === "sale-40off" 
              	|| boostPFSConfig.general.collection_handle === "sale-35off" 
              	|| boostPFSConfig.general.collection_handle === "sale-30off" 
              	|| boostPFSConfig.general.collection_handle === "sale-25off" 
              	|| boostPFSConfig.general.collection_handle === "sale-mujer-25off" 
              	|| boostPFSConfig.general.collection_handle === "sale-mujer-30off" 
              	|| boostPFSConfig.general.collection_handle === "sale-mujer-35off"  
              	|| boostPFSConfig.general.collection_handle === "sale-mujer-40off" 
              	|| boostPFSConfig.general.collection_handle === "sale-mujer-50off" 
              	|| boostPFSConfig.general.collection_handle === "sale-hombre-25off" 
              	|| boostPFSConfig.general.collection_handle === "sale-hombre-30off" 
              	|| boostPFSConfig.general.collection_handle === "sale-hombre-35off" 
              	|| boostPFSConfig.general.collection_handle === "sale-hombre-40off" 
              	|| boostPFSConfig.general.collection_handle === "sale-hombre-50off" 
              	|| boostPFSConfig.general.collection_handle === "sale-ninos-bebes-25off" 
              	|| boostPFSConfig.general.collection_handle === "sale-ninos-bebes-30off" 
              	|| boostPFSConfig.general.collection_handle === "sale-ninos-bebes-35off" 
              	|| boostPFSConfig.general.collection_handle === "sale-ninos-bebes-40off" 
              	|| boostPFSConfig.general.collection_handle === "sale-ninos-bebes-50off" 
              	|| boostPFSConfig.general.collection_handle === "mas-elegidos" 
              	|| boostPFSConfig.general.collection_handle === "regalos-con-descuentos-dia-del-padre" ) {
				if(is_available) {
					swatchesProductOptionHtml += `<li data-avail=${is_available} js-upper class="${onSale ? 'on-sale' : ''} ${hideSwatch ? 'swatch-hidden' : ''}">`;
					if(optionName == 'color' || optionName == 'colour'){
					  swatchesProductOptionHtml += '<div class="boost-pfs-product-item-tooltip">' + swatchName + '</div>';
					  swatchesProductOptionHtml += '<span js-swatch-img data-variant-id="'+ variant.id +'" class="'+ activeClass +'" data-product-id="'+ data.id +'" data-value="' + swatchValues[sIndex].title +'" data-new="'+ newProduct +'" data-web="'+ webSpecialTag +'" data-on-sale="'+ onSale +'" data-price-min="'+ data.price_min +'" data-price-min-nosale="'+ nosalePrice +'" data-price-max="'+ data.price_max +'" data-price="'+ priceMin +'" data-compared-price="'+ comparedPriceMin +'" tabindex="0" aria-label="' + swatchName + '" ' +
						'style="background-color: ' + swatchName + '; ';
					  if (bgImageSrc != '') {
						swatchesProductOptionHtml += 'background-image: url(' + bgImageSrc + ');" ';
					  } else {
						swatchesProductOptionHtml += '" ';
					  }
					  if (dataImgSrc != '') {
                        swatchesProductOptionHtml += 'data-img="' + dataImgSrc + '" data-back-img="'+ dataBackImgSrc +'" ';
					  }
	
					  swatchesProductOptionHtml += '></span>';
					} else {
					  swatchesProductOptionHtml += '<a title="' + swatchName + '" href="' + Utils.buildProductItemUrl(data) + '?variant=' + swatchVariant.id + '">' + swatchName + '</a>';
					}
					swatchesProductOptionHtml += '</li>';
					if (hideSwatch) hiddenSwatchCount++;
					count++;
				}
              } else if (boostPFSConfig.general.collection_handle !== "web-specials") { 
				if(is_available) { 
					let available_onlyweb = false
					let available_newcolor = false
					let is_redesigned = false
					if(onlyWebLabel != '' || variantIDMetaOnlyWeb == variant.id) {
						available_onlyweb= true
					} else {
						available_onlyweb = false
					}
					if(newColorLabel != '' || variantIDMetaNewColor == variant.id) {
						available_newcolor = true
					}
					if(redesignedLabel != '' ) {
						is_redesigned = true
					}
					
					swatchesProductOptionHtml += `<li data-avail="${is_available}" js-lower class="${hideSwatch ? 'swatch-hidden' : ''}" >`;
					if(optionName == 'color' || optionName == 'colour'){
					  swatchesProductOptionHtml += '<div class="boost-pfs-product-item-tooltip">' + swatchName + '</div>';
					  swatchesProductOptionHtml += `<span js-swatch-img data-variant-id=${variant.id}  data-only-web=${available_onlyweb} data-new-color=${available_newcolor} data-redesigned=${is_redesigned} class= '${activeClass}' data-product-id=${data.id} data-value= ${swatchValues[sIndex].title}  data-new= ${newProduct} data-web= ${webSpecialTag} data-price-varies= ${priceVaries}  data-on-sale=${onSale} data-price-min=${data.price_min}  data-price-min-nosale= ${nosalePrice} data-price-max=${data.price_max} data-price=${priceMin} data-compared-price=${comparedPriceMin} tabindex="0" aria-label= ${swatchName}
						style="background-color: ${swatchName} ; `;
					  if (bgImageSrc != '') {
						swatchesProductOptionHtml += 'background-image: url(' + bgImageSrc + ');" ';
					  } else {
						swatchesProductOptionHtml += '" ';
					  }
					  if (dataImgSrc != '') {
						swatchesProductOptionHtml += 'data-img="' + dataImgSrc + '" data-back-img="'+ dataBackImgSrc +'" ';
					  }
					  
					  swatchesProductOptionHtml += '></span>';
					} else {
					  swatchesProductOptionHtml += '<a title="' + swatchName + '" href="' + Utils.buildProductItemUrl(data) + '?variant=' + swatchVariant.id + '">' + swatchName + '</a>';
					}
					swatchesProductOptionHtml += '</li>';
					if (hideSwatch) hiddenSwatchCount++;
					count++;
				}
				
              }
            }
            colorCount = count;
			if (hiddenSwatchCount > 0) {

				swatchesProductOptionHtml += `
					<li class="swatch-more-count">
						<h3 class="swatch-more-trigger">+${hiddenSwatchCount}</h3>
					</li>
				`;
			}
            swatchesProductOptionHtml += '</ul>';
          }
        }
      }
      return swatchesProductOptionHtml;
    }

		jQ(document).on('click', '.swatch-more-trigger', function () {
			const $swatchList = jQ(this).closest('.boost-pfs-filter-item-swatch');
			if (!$swatchList.length) return;
		
			const $product = $swatchList.closest('.boost-pfs-filter-product-item');
			if (!$product.length) return;
		
			// ✅ FIRST swatch
			const $firstSwatch = $swatchList.find('li span[js-swatch-img]').first();
			if (!$firstSwatch.length) return;
		
			const variantId = $firstSwatch.data('variant-id');
		
			const $link = $product.find('.boost-pfs-filter-product-item-image-link');
			let href = $link.attr('href');
			if (!href) return;
		
			href = href.split('?')[0];
		
			// 🚀 open first swatch product
			window.location.href = `${href}?variant=${variantId}`;
		});

	// Build Color Swatches
	function eventColorSwatches(event,data) {
		jQ('.boost-pfs-filter-item-swatch li span').each(function() {
			var img = jQ(this).parents('.boost-pfs-filter-product-item-inner').find('.boost-pfs-filter-product-item-main-image');
          	var imgSec = jQ(this).parents('.boost-pfs-filter-product-item-inner').find('.boost-pfs-filter-product-item-flip-image');
			var labels = jQ(this).parents('.boost-pfs-filter-product-item-inner').find('.boost-pfs-filter-product-item-label');

            var link = jQ(this).parents('.boost-pfs-filter-product-item-inner').find('.boost-pfs-filter-product-item-image-link');
          	var currentHref = link.attr('href');
            
          	var labelsInit = labels.html();
		
          	if (event == 'hover') {
				jQ(this).on('hover', function() {
                  	jQ(this).closest('.boost-pfs-filter-item-swatch ').find('li span').removeClass('active');
                  	jQ(this).addClass('active');
					
					var newImage = jQ(this).data('img');
					img.attr('srcset', newImage);
				});
			}
			if (event == 'click') {
				// console.log('this', this);
				jQ(this).on('click', function() {
                  	jQ(this).closest('.boost-pfs-filter-item-swatch ').find('li span').removeClass('active');
                    var variantId = jQ(this).data('variant-id');
					link.attr('href', currentHref + '?variant=' + variantId);
                  	var newImage = jQ(this).data('img');
                  	var newBackImage = jQ(this).data('back-img');
					img.attr('srcset', newImage);


					const variantId1 = jQ(this).data('variant-id');
					const selectedProduct1 = data.products.find(item => item.id === jQ(this).data('product-id'));
					
					if (!selectedProduct1) return;
					
					let newColorBadge = false;
					let newBadge = false;

					// Filter metafields for this variant (use `id` instead of `variant_id`)
					const variantMetafields = selectedProduct1.metafields.filter(
							m => Number(m.id) === Number(variantId1)
					);
					
					// Look for 'new_color' and 'start_date_badge'
					const newColorField = variantMetafields.find(
							m => m.key === 'new_color' && m.value?.trim().toLowerCase() === 'new color'
					);
					
					const startDateField = variantMetafields.find(
							m => m.key === 'start_date_badge' && m.value?.trim() !== ''
					);

					const variantIsWithinDays = (metafieldval, daysLimit = 60) => {
				
						const startDate = new Date(metafieldval);
					
						const now = new Date();
						const diffMs = now.getTime() - startDate.getTime();
					
						const diffDays = Math.round(diffMs / (1000 * 60 * 60 * 24));
					
						return diffDays >= 0 && diffDays <= daysLimit;
					}; 

				
					if (startDateField) {
						const showBadge = variantIsWithinDays(startDateField.value);
						if (showBadge) {
							// "New" badge logic
							newBadge = true;
					
						// "New Color" logic (only if both fields exist)
							if (newColorField) {
								newColorBadge = true;
							}
						}
					}

                  	if(newBackImage) {
                  		imgSec.attr('srcset', newBackImage);
                    } else {
                    	imgSec.attr('srcset', newImage);
                    }
                  	jQ(this).addClass('active');
                  
                  	var onSale = jQ(this).data('on-sale');
                  	var prodPriceVaries = jQ(this).data('price-varies');
                  	var webBadge = jQ(this).data('web');
                  	var newProduct = jQ(this).data('new');
                  	var priceMin = parseFloat(jQ(this).data('price'));
					var onlyweb = jQ(this).data('only-web');
					var newColor = jQ(this).data('new-color')
					var redesignedLabel = jQ(this).data('redesigned');
                  	var comparedPriceMin = parseFloat(jQ(this).data('compared-price'));

					// console.log({onlyweb})
                  	if(webBadge && onSale) {
                        var discount = Math.round(((comparedPriceMin - priceMin) * 100)/comparedPriceMin)
                      	var badgeHtml = '<span class="pp sale boost-pfs-filter-label web-badge">'+ discount +'% OFF</span>';
                      	//var badgeHtml = '<span class="pp sale boost-pfs-filter-label web-badge">Web Special</span>';
                      	//var badgeHtml = '<span class="pp sale boost-pfs-filter-label web-badge">Sale</span>';
												// if(newColorBadge) {
												// 	badgeHtml += '<span class="sale boost-pfs-filter-label web-badge onlyweb">New Color</span>';
												// } 
                  		labels.html(badgeHtml);
                    }else if(onSale && onlyweb) {
						
						var discount = Math.round(((comparedPriceMin - priceMin) * 100)/comparedPriceMin)
                      	var badgeHtml = '<span class="sale boost-pfs-filter-label web-badge">'+ discount +'% OFF</span>';
                      	//var badgeHtml = '<span class="aa sale boost-pfs-filter-label web-badge">Sale</span>';
						badgeHtml += '<span class="sale boost-pfs-filter-label web-badge onlyweb">Only Web</span>';
						labels.html(badgeHtml)
					}else if (onSale) {  
                      	var discount = Math.round(((comparedPriceMin - priceMin) * 100)/comparedPriceMin)
                      	var badgeHtml = '<span class="sale boost-pfs-filter-label web-badge">'+ discount +'% OFF</span>';
                      	//var badgeHtml = '<span class="nn sale boost-pfs-filter-label web-badge">Sale</span>';
                  		labels.html(badgeHtml);
                    } else if(!onSale && newProduct && newBadge && !newColorBadge) {
                    	var newLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, 'Nuevo');
                    	labels.html(newLabel);
                    } else if(webBadge && newProduct) {
                    	var newLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, '');
                    	labels.html(newLabel);
                    }else if(onlyweb) {
						var newLabel = '<span class="sale boost-pfs-filter-label web-badge onlyweb">Only Web</span>';
                    	labels.html(newLabel);
					} else if(redesignedLabel) {
						var newLabel = '<span class="sale boost-pfs-filter-label web-badge onlyweb">Redesigned</span>';
                    	labels.html(newLabel);
					}
					 else {
                      labels.html('');
                    }
					

					// --- ALWAYS ADD NEW COLOR BADGE IF TRUE ---
						if (newColorBadge) {
							let currentHtml = labels.html() || '';

							// avoid duplicate
							if (!currentHtml.includes('New Color')) {

								// ADD onlyweb class ONLY when collection_handle === "web-specials"
								const onlywebClass =
									boostPFSConfig?.general?.collection_handle === "web-specials"
										? " onlyweb"
										: "";

								const badge =
									'<span class="sale boost-pfs-filter-label web-badge onlyweb">Nuevo Color</span>';

								labels.html(currentHtml + badge);
							}
						}



                  	// Update price
                    if (onSale) {
                      	var html = '';
                      	var comparePrice = parseFloat(jQ(this).data('compared-price'));
						if(typeof comparePrice == 'number') {
							html += '<s>' + Utils.formatMoney(comparePrice) + '</s>';
							html += '<span class="boost-pfs-filter-product-item-sale-price cc"><span class="pricedetector">saleckick</span> ' + Utils.formatMoney(priceMin) + '</span>';
						
							jQ(this).parents('.boost-pfs-filter-product-item-image').find('.boost-pfs-filter-product-item-price').html(html);
						}

                    } else if (prodPriceVaries) {
                     	var rawPriceMax = parseFloat(jQ(this).data('price-max')); 
                     	var rawPriceMin = parseFloat(jQ(this).data('price-min-nosale')); 


                      	var html = '';
                        if (rawPriceMin <= rawPriceMax) {
                          	html = '<span class="boost-pfs-filter-product-item-price-min aa"><span class="pricedetector">aaa</span> ' + Utils.formatMoney(priceMin) + '</span>';
					    } else {
                            html = '<span class="boost-pfs-filter-product-item-price-min bb"><span class="pricedetector">bbb</span> ' + Utils.formatMoney(rawPriceMin) + '</span>';
                            html += ' - <span class="boost-pfs-filter-product-item-price-min cc"><span class="pricedetector">ccc</span> ' + Utils.formatMoney(rawPriceMax) + '</span>';
                        }
		
                      	jQ(this).parents('.boost-pfs-filter-product-item-image').find('.boost-pfs-filter-product-item-price').html(html);

	
                    } else {
						var html = '';
						html += '<span class="boost-pfs-filter-product-item-price-min dd">' + Utils.formatMoney(priceMin) + '</span>';
					
						jQ(this).parents('.boost-pfs-filter-product-item-image').find('.boost-pfs-filter-product-item-price').html(html);
					}

                    const activeValue = $(this).data("value");
					const productId = $(this).data("product-id");
					const variantItems = $(this).parents(".boost-pfs-filter-product-item").find("[js-variant-item]");

					const selectedProduct = data.products.find( item => item.id === productId);
					const outOfStockVariant = selectedProduct.variants.filter( item => !item.available && item.title.includes(activeValue));
			
					const selectedVariantList = selectedProduct.variants.filter( item => item.title.includes(activeValue));
					// place for metafield label setting for specific swatch item i.e., li span	
					// selectedProduct.metafields.map((metafield) => {
					// 	console.log("value" , metafield.value, " namescpace" , metafield.namespace, "id ", metafield.id, "selectedVariantList[0].id", selectedVariantList[0].id )
					// 	if(metafield.namespace == 'custom' && metafield.value == "'onlyweb'"){
					// 		console.log("It has meta onlyweb")
					// 	}
					// })


					variantItems.removeClass('disabled');
					variantItems.removeClass('hide');
					if(outOfStockVariant.length) {
						variantItems.each((index,item) => {
							const value = $(item).data('value');
							const variantTitle = `${activeValue} / ${value}`;
							
							outOfStockVariant.forEach( variant => {
								if(variant.title.includes(variantTitle)) {
									$(item).addClass('disabled');
								}
							});
							 
							const selectedVariant = selectedProduct.variants.find( item => item.title.includes(variantTitle) && item.title.includes(activeValue));
							
							if(!selectedVariant) {
								$(item).addClass('hide');
							}
						})
					};

					if(selectedVariantList.length !== variantItems.length) {
						variantItems.each((index,item) => {
							const value = $(item).data('value');
							const variantTitle = `${activeValue} / ${value}`;
							
							const selectedVariant = selectedProduct.variants.find( item => item.title.includes(variantTitle) && item.title.includes(activeValue));
							
							if(!selectedVariant) {
								$(item).addClass('hide');
							}
						})
					}
				});
            }
			jQ(this).focus(function() {
				if (jQ('body').hasClass('boost-pfs-ada')) {
					var newImage = jQ(this).data('img');
					img.attr('srcset', newImage);
				}
			});
		});
	}

	function buildReview(data) {
		var html = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('show_product_review') &&
			boostPFSThemeConfig.custom.show_product_review == true) {
			html = '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>';
		}
		return html;
	}

	function buildActiveSwapClass(data) {
		if (!Utils.isMobile() &&
			boostPFSThemeConfig.custom.hasOwnProperty('active_image_swap') &&
			boostPFSThemeConfig.custom.active_image_swap == true) {
			return 'has-bc-swap-image';
		}
		return '';
	}



	/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
	/************************** BUILD TOOLBAR **************************/
	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
		// If it has only one page, clear Pagination
		if (totalPage <= 1) {
			return '';
		}

		var paginationHtml = boostPFSTemplate.paginateHtml;
		// Build Previous
		var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
		// Build Next
		var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
		// Create page items array
		var beforeCurrentPageArr = [];
		for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
			beforeCurrentPageArr.unshift(iBefore);
		}
		if (currentPage - 4 > 0) {
			beforeCurrentPageArr.unshift('...');
		}
		if (currentPage - 4 >= 0) {
			beforeCurrentPageArr.unshift(1);
		}
		beforeCurrentPageArr.push(currentPage);
		var afterCurrentPageArr = [];
		for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
			afterCurrentPageArr.push(iAfter);
		}
		if (currentPage + 3 < totalPage) {
			afterCurrentPageArr.push('...');
		}
		if (currentPage + 3 <= totalPage) {
			afterCurrentPageArr.push(totalPage);
		}
		// Build page items
		var pageItemsHtml = '';
		var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
		for (var iPage = 0; iPage < pageArr.length; iPage++) {
			if (pageArr[iPage] == '...') {
				pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
			} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
			}
			pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
			pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
		}
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
		return paginationHtml;
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSThemeConfig.custom.show_toolbar_sort_by && boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				var paramSort = Globals.queryParams.sort || '';
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					var activeClass = '';
					if (paramSort == k) {
						activeClass = 'boost-pfs-filter-sort-item-active';
					}
					sortingItemsHtml += '<li><a href="#" data-sort="' + k + '" class="' + activeClass + '">' + sortingArr[k] + '</a></li>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};

	ProductSorting.prototype.render = function() {
		jQ(Selector.topSorting).html(this.compileTemplate());

		if (jQ('.boost-pfs-filter-custom-sorting').hasClass('boost-pfs-filter-sort-active')) {
			jQ('.boost-pfs-filter-custom-sorting').toggleClass('boost-pfs-filter-sort-active');
		}

		var labelSort = '';
		var paramSort = Globals.queryParams.sort || '';
		var sortingList = Utils.getSortingList();
		if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
			labelSort = sortingList[paramSort];
		} else {
			labelSort = Labels.sorting_heading;
		}

		jQ('.boost-pfs-filter-custom-sorting button span span').text(labelSort);
	}

	// Build Sorting event
    ProductSorting.prototype.bindEvents = function() {
      var _this = this;
      jQ('.boost-pfs-filter-filter-dropdown a').click(function(e) {
        e.preventDefault();
        FilterApi.setParam('sort', jQ(this).data('sort'));
        FilterApi.setParam('page', 1);
        FilterApi.applyFilter('sort');
      });

      jQ(".boost-pfs-filter-custom-sorting > button").click(function() {
        jQ('.boost-pfs-filter-filter-dropdown').toggle().parent().toggleClass('boost-pfs-filter-sort-active');
      });

      jQ(Selector.filterTreeMobileButton).click(function() {
        jQ('.boost-pfs-filter-top-sorting-mobile .boost-pfs-filter-filter-dropdown').hide();
      });

      jQ(document).on('click', function (e) {
        if (jQ(e.target).parents('.boost-pfs-filter-top-sorting').find(".boost-pfs-filter-filter-dropdown").length === 0) {
          jQ('.boost-pfs-filter-filter-dropdown').hide().parent().removeClass('boost-pfs-filter-sort-active');
        }
      });
    };
	// For Toolbar - Build Display type
	ProductDisplayType.prototype.compileTemplate = function() {
		var itemHtml = '<span>' + boostPFSThemeConfig.label.toolbar_viewas + '</span>';
		if (boostPFSThemeConfig.custom.product_item_type == 'grid') {
            if (boostPFSThemeConfig.custom.view_as_type == 'view_as_type_list_grid_multi_col' && !Utils.isMobile()) {
                itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"></span></a>';
                itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-2" data-view="grid-2"><span class="icon-fallback-text"></span></a>';
                itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-3" data-view="grid-3"><span class="icon-fallback-text"></span></a>';
                itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-4" data-view="grid-4"><span class="icon-fallback-text"></span></a>';
                itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-5" data-view="grid-5"><span class="icon-fallback-text"></span></a>';
                itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-6" data-view="grid-6"><span class="icon-fallback-text"></span></a>';
            } else {
                itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"></span></a>';
                itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"></span></a>';
            }
		} else {
            if (boostPFSThemeConfig.custom.view_as_type == 'view_as_type_list_grid_multi_col' && !Utils.isMobile()) {
                itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"></span></a>';
                itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-2" data-view="grid-2"><span class="icon-fallback-text"></span></a>';
                itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-3" data-view="grid-3"><span class="icon-fallback-text"></span></a>';
                itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-4" data-view="grid-4"><span class="icon-fallback-text"></span></a>';
                itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-5" data-view="grid-5"><span class="icon-fallback-text"></span></a>';
                itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-6" data-view="grid-6"><span class="icon-fallback-text"></span></a>';
            } else {
                itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"></span></a>';
			    itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"></span></a>';
            }
		}

		itemHtml = itemHtml.replace(/{{class.productDisplayType}}/g, Class.productDisplayType);

		return itemHtml;
	};

    var originalRenderProductDisplayType = ProductDisplayType.prototype.render;
    ProductDisplayType.prototype.render = function() {
      // Call the original function in our app lib.
      // We don't have to copy a very big function out here to modify.
      // function.call(this, param1, param2) binds the "this" pointer and params to the original function.
      originalRenderProductDisplayType.call(this);

      // Do your custom code after the original function has run
      // Active current display type
      if (this.$element.length) {
        this.$element.find(this.selector.productDisplayTypeList).removeClass('active');
        this.$element.find(this.selector.productDisplayTypeGrid).removeClass('active');
        if (Globals.queryParams.display == 'list') {
          this.$element.find(this.selector.productDisplayTypeList).addClass('active');
        } else if (Globals.queryParams.display == 'grid') {
          if (boostPFSThemeConfig.custom.view_as_type == 'view_as_type_list_grid_multi_col' && !Utils.isMobile()) {
            var curentGridColumn = boostPFSThemeConfig.custom.products_per_row;
            this.$element.find(this.selector.productDisplayTypeGrid).each(function(){
              var $parent = jQ(this).parent();
              var $cssNames = jQ('.boost-pfs-filter-top-display-type').attr('class').split(' ');
              var $activeClass = $cssNames[$cssNames.length - 1];
              var indexCurrentColumn = $activeClass.split('-')[$activeClass.split('-').length - 1];

              if($parent.hasClass('boost-pfs-filter-view-as-click') && jQ(this).data('view') == $activeClass){
                jQ(this).addClass('active');
                jQ('.boost-pfs-filter-product-item').removeClass(function(index, css) {
                  return (css.match (/(^|\s)boost-pfs-filter-grid-width-\S+/g) || []).join(' ');
                }).addClass('boost-pfs-filter-grid-width-' + indexCurrentColumn);
              } else if(!$parent.hasClass('boost-pfs-filter-view-as-click') && jQ(this).data('view').split('-')[1] == curentGridColumn) {    
                jQ(this).addClass('active');
              }
            });

          } else {
            this.$element.find(this.selector.productDisplayTypeGrid).addClass('active');
          }
        }
      }
    }

	// Build Show Limit
	ProductLimit.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSThemeConfig.custom.show_limit && boostPFSTemplate.hasOwnProperty('showLimitHtml')) {

			var numberList = Settings.getSettingValue('general.showLimitList');
			if (numberList != '') {
				// Build content
				var showLimitItemsHtml = '';
				var arr = numberList.split(',');
				for (var k in sortingArr) {
					showLimitItemsHtml += '<option value="' + arr[k].trim() + '">' + arr[k].trim() + '</option>';
				}
				html = boostPFSTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
			}
		}
		return html;
	};
	// Build Breadcrumb
	Breadcrumb.prototype.compileTemplate = function(colData) {
		if (!colData) colData = this.collectionData;
		var breadcrumbItemsHtml = '';
		if (boostPFSTemplate.hasOwnProperty('breadcrumbHtml')) {
			if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
				var colInfo = colData.collection;
				if (typeof this.collectionTags !== 'undefined' && this.collectionTags !== null) {
					breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemLink.replace(/{{itemLink}}/g, '/collections/' + colInfo.handle).replace(/{{itemTitle}}/g, colInfo.title);
					breadcrumbItemsHtml += " {{breadcrumbDivider}} ";
					breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.collectionTags[0]);
				} else {
					breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, colInfo.title);
				}
			} else {
				breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, Settings.getSettingValue('label.defaultCollectionHeader'));
			}
		}
		return breadcrumbItemsHtml
	};

	/************************** END BUILD TOOLBAR **************************/

	// Add additional feature for product list, used commonly in customizing product list
      function customBuildProductImages (){
		const activeSwatch = $("[js-swatch-img].active");

		activeSwatch.each((index, swatch) => {
			const frontImage = $(swatch).data('img');
			const backImage = $(swatch).data('back-img');
			const parent = $(swatch).parents('.boost-pfs-filter-product-item-inner');
			const frontImageTag = parent.find('.boost-pfs-filter-product-item-main-image');
			const backImageTag = parent.find('.boost-pfs-filter-product-item-flip-image');
			
			frontImageTag.attr('src', frontImage);
			frontImageTag.attr('data-src', frontImage);
			frontImageTag.attr('data-srcset', frontImage);
			if(backImage){
				backImageTag.attr('src', backImage);
				backImageTag.attr('data-src', backImage);
				backImageTag.attr('data-srcset', backImage);
			} else {
				backImageTag.attr('src', frontImage);
				backImageTag.attr('data-src', frontImage);
				backImageTag.attr('data-srcset', frontImage);
			}
			
			
		})

	}

	customBuildProductImages();
	
	ProductList.prototype.afterRender = function(data) {
		if (!data) data = this.data;
		this.buildExtrasProductListByAjax(data, 'boost-product-description', function(results) {
			results.forEach(function(result) {
				var element = jQ('.boost-pfs-filter-product-item[data-id="'+result.id+'"]')
				element.find('.pfs-des-custom').html(result.product_description)
			});
		});

      // ProductList.prototype.afterRender = function(){
		// console.log('ProductList.prototype.afterRender')
		customBuildProductImages();
		setTimeout(() => {
			customBuildProductImages();
		}, 500)
	// }

		// Intergrate Review Shopify
		if (window.SPR &&
			typeof window.SPR.initDomEls == 'function' &&
			typeof window.SPR.loadBadges == 'function' &&
			boostPFSThemeConfig.custom.show_product_review) {
			window.SPR.initDomEls();
			window.SPR.loadBadges();
		}
	};

	// Build additional elements
	Filter.prototype.afterRender = function(data) {
		if (!data) data = this.data;

		var totalProduct = data.total_product + '<span> ' + boostPFSThemeConfig.label.items_with_count_other + '</span>';
		if (data.total_product == 1) {
			totalProduct = data.total_product + '<span> ' + boostPFSThemeConfig.label.items_with_count_one + '</span>';
		}
		jQ('.boost-pfs-filter-total-product').html(totalProduct);

		jQ('body').find('.boost-pfs-filter-skeleton-button').remove();

		// Prevent double tap on iOS
		var isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
		if (isiOS) {
			Utils.isMobile() && jQ(".boost-pfs-filter-product-item").find("a").on("touchstart", function() {
				isScrolling = !1
			}).on("touchmove", function() {
				isScrolling = !0
			}).on("touchend", function() {
				isScrolling || (window.location = jQ(this).attr("href"))
			});
		}

		// Build Image Swap. Put this function here to impprove the pagespeed.
		swapImage(data);

		// Build Equal Height
		if (Globals.queryParams.display !== 'list') {
			equalHeight(data);
		};

		jQ(window).resize(function() {
			if (Globals.queryParams.display !== 'list') {
				equalHeight(data);
			}
		});

		// Build Event Color Swatch
		if (boostPFSThemeConfig.custom.swatch_color_event_change_image != 'none') {
			eventColorSwatches(boostPFSThemeConfig.custom.swatch_color_event_change_image,data);
		}

		if (typeof boostRemoveImageLoadingAnimation == 'function') {
			boostRemoveImageLoadingAnimation(jQ(Selector.products).find('[data-boost-image-loading-animation]'));
		}
        /* Filter Sticky */
        if (boostPFSThemeConfig.custom.hasOwnProperty('enable_filter_sticky') && boostPFSThemeConfig.custom.enable_filter_sticky && !Utils.isMobile()) {
            if(jQ('.boost-pfs-filter-left-col-inner').length > 0){
                var stickyElemet = '.boost-pfs-filter-left-col-inner';
                var stickyElementParent = '.boost-pfs-filter-left-col';
                var startElement = '.boost-pfs-filter-products';
                jQ(stickyElemet).stickTo(startElement,stickyElementParent);
            }
        }
        /* End Filter Sticky */

        /* Init Sticky Mobile */
        stickyFilterMobile();
        jQ(window).scroll(stickyFilterMobile);

        /* Init Sticky Horizontal */
        stickyFilterHorizontal();
        jQ(window).scroll(stickyFilterHorizontal);

		/* Layout Fullwidth Page */
		if (boostPFSThemeConfig.custom.hasOwnProperty('layout_type') && boostPFSThemeConfig.custom.layout_type == 'fullwidth' && !Utils.isMobile()) {
			jQ('body').addClass('boost-pfs-filter-fullwidth-page');
		}

		const quickAtcBlock = $("[js-atc-block]");
		const variantItem = $("[js-variant-item]");
		const quickAtcBtn = $("[js-atc-btn]");

		function addProductToCart(selectedProduct, selectedVariant) {
			if (!selectedProduct || !selectedVariant) return;
		
			$.ajax({
				type: 'POST',
				url: '/cart/add.js',
				data: {
					quantity: 1,
					id: selectedVariant.id
				},
				dataType: 'json',
				success: function (response) {
					jQuery.getJSON('/cart.js').done(function (items) {
						$('.site-header__cart .counter').html(items.item_count);
					});
		
					initProductModal(selectedProduct, selectedVariant, response.price);
				}
			});
		}
		
		quickAtcBtn.click(function () {
			const targetProduct = $(this).parents('.boost-pfs-filter-product-item');
			const productId = $(this).data('product-id');
			const selectedProduct = data.products.find(item => item.id === productId);
		
			if (!selectedProduct) return;
		
			if ($(this).hasClass('has-multiple-variant')) {
				quickAtcBlock.removeClass('active');
				$(this).parent('[js-atc-block]').addClass('active');
				return;
			}
		
			const selectedValue = targetProduct.find('[js-swatch-img].active').data('value');
		
			let selectedVariant = null;
		
			if (selectedValue) {
				selectedVariant = selectedProduct.variants.find(item =>
					item.title.includes(selectedValue) && item.available
				);
			}
		
			if (!selectedVariant) {
				selectedVariant = selectedProduct.variants.find(item => item.available);
			}
		
			addProductToCart(selectedProduct, selectedVariant);
		});
		

		variantItem.click(function () {
			const targetProduct = $(this).parents('.boost-pfs-filter-product-item');
			const productId = $(this).data('product-id');
			const value = $(this).data('value');
		
			const selectedProduct = data.products.find(item => item.id === productId);
			if (!selectedProduct) return;
		
			const selectedValue = targetProduct.find('[js-swatch-img].active').data('value');
		
			const selectedVariant = selectedProduct.variants.find(
				item => item.title === `${selectedValue} / ${value}`
			);
		
			addProductToCart(selectedProduct, selectedVariant);
		});

		function initProductModal(product, variant, variantPrice) {
			renderPopup(product, variant, variantPrice);

			$('[js-close-btn]').click(function() {
				$('[js-pdp-popup]').remove();
			})
			// Obtiene el elemento del loader
          const loader = document.querySelector('.loader');
          const mainpdp = document.querySelector('.main-pdp-popup .popup');

            // Oculta el loader después de 2 segundos
          setTimeout(() => {
            loader.style.display = 'none';
            mainpdp.style.opacity = 1;
            }, 2000); // 2000 milisegundos = 2 segundos
		};

		function renderPopup(product, variant, variantPrice) {
			$('body').append(`
				<div class="main-pdp-popup" data-toggle="modal" js-pdp-popup>
					<div class="add-to-cart-notification">
						<div class="loader">
            	<svg class="patagonia-loading" viewBox="0 0 262 50" aria-labelledby="picon--patagonia-loading-desc picon--patagonia-loading-title" id="icon--patagonia-loading" xmlns="http://www.w3.org/2000/svg">
                <title id="picon--patagonia-loading-title">Loading ...</title>
                <desc id="picon--patagonia-loading-desc">Patagonia Loading Icon</desc>
                <path class="mountains" d="M5 44.8l1.8-.7c2.1-.8 4.2-1.6 6.2-2.4.9-.4 1.6-.9 2.2-1.6 1-1.1 1.9-2.2 2.8-3.4.8-1 1.5-2 2.2-3 1.1-1.5 2.3-2.9 3.6-4.2.8-.9 1.7-1.8 2.6-2.7.7-.7 1.2-.6 1.8.1.9 1 1.6 2.2 2.4 3.3 1.2 1.6 2.5 3.1 3.9 4.5.9.8 1.9 1.5 2.9 2.1 2.7 1.5 5.5 2.7 8.4 4 1.4.6 2.9 1.3 4.2 2.1 1 .7 2.2 1.2 3.4 1.5 1.4.3 2.8-.2 3.6-1.3 1.7-2.2 3.3-4.4 5.1-6.6.9-1.2 2-2.3 3-3.5.2-.2.4-.5.7-.7.6-.7 1.7-.7 2.4-.1l.2.2c1.6 1.8 3.3 3.4 5.2 4.9 1.1 1 2.2 2 3.3 2.9.4.4.9.8 1.4 1.1.8.8 2 .8 2.8.1.5-.4 1-.9 1.3-1.4.6-1 1.1-2 1.7-3 .8-1.5 1.7-3 2.6-4.5.3-.5.6-1 1-1.4 1.6-2.2 3.6-4 5.9-5.6.6-.7 1.7-.7 2.3-.1l.1.1c.4.3.8.6 1.1 1 1.2 1.4 2.3 2.9 3.2 4.5.9 1.5 2.2 2.7 3.8 3.4l9.3 4.6.6.3c.6.3.8.3 1.1-.2 1.5-1.8 3.4-3.1 5-4.7.1-.1.2-.2.4-.3.2-.2.5-.2.8-.1.7.3 1.3.5 2 .8 1 .5 2 1 2.9 1.5.6.4 1.4.4 2 0 .6-.4 1.2-.8 1.7-1.3 1.5-1.4 2.9-2.7 4.3-4.2 1.9-1.9 3.7-4 5.6-5.9 1.7-1.7 3-3.7 4.1-5.8.4-.9 1-1.7 1.7-2.4 3.7-4 7.5-8 11.4-11.9.3-.4.9-.5 1.3-.2 1.2.6 2.4 1.2 3.5 2 1.4 1 2 2.5 2.5 4.1.6 1.8 1 3.6 1.3 5.5.5 2.5 1 4.9 1.6 7.3 0 .2.1.3.1.5.3 1.1.3 1.1 1.6 1 1.4-.1 2.7-.5 3.9-1.1.6-.3 1.2-.5 1.8-.6.7-.1 1.4.2 1.8.8.8 1.1 1.5 2.2 2.2 3.4.6 1.1 1.2 2.3 1.8 3.5 1.3 2.9 2.4 5.9 3.4 9l.3.9c.4 1 .6 1.2 1.7 1.1 1-.1 1.9-.3 2.8-.8 1.2-.7 2.4-1.3 3.5-2 1-.6 2-1.1 3-1.6 2-.8 4-1.7 6-2.5.6-.3 1.3-.3 1.9 0 1.6.7 3.2 1.3 4.8 2.1.6.3 1.3.3 1.8 0 .4-.2.9-.4 1.4-.6l7.4-3.3c.3-.1.6-.2.9-.4.4-.2.9-.1 1.1.3.7.8 1.4 1.7 2.1 2.5 1.1 1.2 2.6 2.2 4.1 2.8.8.3 1.6.3 2.4-.1 2.6-1 5.2-2.2 7.7-3.6.9-.6 2.1-.5 3 .2 3.2 2.2 6.6 4.1 9.9 6.2 2 1.2 4 2.4 6 3.5l1.2.7">
                </path>
                <path class="mountains-animated" d="M5 44.8l1.8-.7c2.1-.8 4.2-1.6 6.2-2.4.9-.4 1.6-.9 2.2-1.6 1-1.1 1.9-2.2 2.8-3.4.8-1 1.5-2 2.2-3 1.1-1.5 2.3-2.9 3.6-4.2.8-.9 1.7-1.8 2.6-2.7.7-.7 1.2-.6 1.8.1.9 1 1.6 2.2 2.4 3.3 1.2 1.6 2.5 3.1 3.9 4.5.9.8 1.9 1.5 2.9 2.1 2.7 1.5 5.5 2.7 8.4 4 1.4.6 2.9 1.3 4.2 2.1 1 .7 2.2 1.2 3.4 1.5 1.4.3 2.8-.2 3.6-1.3 1.7-2.2 3.3-4.4 5.1-6.6.9-1.2 2-2.3 3-3.5.2-.2.4-.5.7-.7.6-.7 1.7-.7 2.4-.1l.2.2c1.6 1.8 3.3 3.4 5.2 4.9 1.1 1 2.2 2 3.3 2.9.4.4.9.8 1.4 1.1.8.8 2 .8 2.8.1.5-.4 1-.9 1.3-1.4.6-1 1.1-2 1.7-3 .8-1.5 1.7-3 2.6-4.5.3-.5.6-1 1-1.4 1.6-2.2 3.6-4 5.9-5.6.6-.7 1.7-.7 2.3-.1l.1.1c.4.3.8.6 1.1 1 1.2 1.4 2.3 2.9 3.2 4.5.9 1.5 2.2 2.7 3.8 3.4l9.3 4.6.6.3c.6.3.8.3 1.1-.2 1.5-1.8 3.4-3.1 5-4.7.1-.1.2-.2.4-.3.2-.2.5-.2.8-.1.7.3 1.3.5 2 .8 1 .5 2 1 2.9 1.5.6.4 1.4.4 2 0 .6-.4 1.2-.8 1.7-1.3 1.5-1.4 2.9-2.7 4.3-4.2 1.9-1.9 3.7-4 5.6-5.9 1.7-1.7 3-3.7 4.1-5.8.4-.9 1-1.7 1.7-2.4 3.7-4 7.5-8 11.4-11.9.3-.4.9-.5 1.3-.2 1.2.6 2.4 1.2 3.5 2 1.4 1 2 2.5 2.5 4.1.6 1.8 1 3.6 1.3 5.5.5 2.5 1 4.9 1.6 7.3 0 .2.1.3.1.5.3 1.1.3 1.1 1.6 1 1.4-.1 2.7-.5 3.9-1.1.6-.3 1.2-.5 1.8-.6.7-.1 1.4.2 1.8.8.8 1.1 1.5 2.2 2.2 3.4.6 1.1 1.2 2.3 1.8 3.5 1.3 2.9 2.4 5.9 3.4 9l.3.9c.4 1 .6 1.2 1.7 1.1 1-.1 1.9-.3 2.8-.8 1.2-.7 2.4-1.3 3.5-2 1-.6 2-1.1 3-1.6 2-.8 4-1.7 6-2.5.6-.3 1.3-.3 1.9 0 1.6.7 3.2 1.3 4.8 2.1.6.3 1.3.3 1.8 0 .4-.2.9-.4 1.4-.6l7.4-3.3c.3-.1.6-.2.9-.4.4-.2.9-.1 1.1.3.7.8 1.4 1.7 2.1 2.5 1.1 1.2 2.6 2.2 4.1 2.8.8.3 1.6.3 2.4-.1 2.6-1 5.2-2.2 7.7-3.6.9-.6 2.1-.5 3 .2 3.2 2.2 6.6 4.1 9.9 6.2 2 1.2 4 2.4 6 3.5l1.2.7">
                </path>
              </svg>
            </div>
						<div class="popup">
							<div class="cross-svg" js-close-btn>
								<svg width="10" viewBox="0 0 10 10"><path d="M9.677 8.118a1.102 1.102 0 11-1.559 1.56L5 6.558 1.882 9.677a1.102 1.102 0 11-1.56-1.559L3.442 5 .323 1.882A1.102 1.102 0 111.882.322L5 3.442 8.118.323a1.102 1.102 0 111.56 1.559L6.558 5l3.118 3.118z" fill="#A1A1A1" fill-rule="nonzero"></path></svg>
							</div>
							<div>
								<div class="container-main-title">
									<h3 class="main-title">Producto agregado al carrito</h3>
								</div>
								<div class="adtc-product-details">
									${ variant.image ? `
									<div class="image">
										<img src=${variant.image} 
										width="50px" height="100px"
										alt=${variant.image?.alt}
										/>
									</div>` : ''
									}
									<div class="adtc-product-details-inner">
										<h2 class="product-title" cart-popup-title>${product.title}</h2>
										<div class="options mt-lg-5">
											${renderOptions(product,variant.title)}
											<p class="variants">Precio: <span class="price">${Utils.formatMoney(variantPrice / 100)}</span> </p>
										</div>						
									</div>
								</div>	
								<div class="buttons text-center mt-lg-5">
									<a href="/cart" class="btn btn-lg btn-dark mb-4">Ir al Carrito</a>
								<a class="btn btn-lg btn-orange" js-close-btn>Seguir comprando</a>
								</div>  
							</div>
						</div>
						
					</div>
				</div>
			`)
		};

		/* mostrar este código para ver iconos e info de materiales en el popup

		//Este fragmento es donde se muestra los iconos

		${ (product.tags.indexOf('iconfairtrade') !== -1 || product.tags.indexOf('iconrecycled') !== -1 || product.tags.indexOf('iconhemp') !== -1 || product.tags.indexOf("iconorganic") !== -1 || product.tags.indexOf("iconresponsiblewool") !== -1) ?
		`
										<div class="tab-grid" id="tab-block">
											<div class="product-materials-info">
												${renderProductMaterailsInfo(product.tags)}                  
											</div>
										</div>
		`
		: ''}

		//final fragmento

		function renderProductMaterailsInfo(tags) {
			let productMaterialInfo = '';
			productMaterialInfo += '<ul class="nav nav-tabs" id="TabTagsProd" role="tablist">';
			tags.forEach( tag => {
				tag.includes('iconfairtrade') ? 
				productMaterialInfo += `
				<li class="nav-item" role="presentation">
					<a class="nav-link" id="fairtrade-tab" data-bs-toggle="tab" href="#fairtradeTab" role="tab" aria-controls="fairtradeTab" aria-selected="true">
						<svg viewBox="0 0 32 32" id="icon--ser--fairtrade" xmlns="http://www.w3.org/2000/svg"><title>Fair Trade</title><g id="mdicons-/-SER-/-Fairtrade" stroke="none" stroke-width="1" fill-rule="evenodd"><path d="M15.537 7.722c5.259 0 9.537 3.556 9.537 7.928a6.74 6.74 0 01-.828 3.21c.572.908.742 1.66.742 1.66.12.51.18 1.039.18 1.573 0 4.828-4.325 8.907-9.446 8.907-5.121 0-9.447-4.079-9.447-8.907 0-1.092.36-2.042.798-2.8C6.372 18.175 6 16.937 6 15.65c0-4.372 4.279-7.928 9.537-7.928zm5.421 6.096l-.035.01c-.062.03-.101.152-.115.232l-.845 3.496c-.012.06.01.08.042.09 0 0-3.745-1.392-8.663.001.034-.012.055-.03.044-.09l-.844-3.497c-.015-.08-.054-.203-.116-.232-.062-.029-.107.005-.206.065l-.136.098c-1.386 1.135-1.545 2.56-1.414 3.705.057.378.174 1.033.3 1.34-.358.382-.68.84-.9 1.385l-.01-.003-.074.28c-.12.446-.18.915-.18 1.395 0 3.998 3.625 7.375 7.916 7.375 4.29 0 7.916-3.377 7.916-7.375 0-.562-.083-1.09-.25-1.614l-.02-.06a4.576 4.576 0 00-.988-1.464c.127-.413.237-.832.302-1.257.128-1.147-.031-2.572-1.417-3.707l-.136-.098c-.099-.06-.144-.094-.206-.065zm-5.365 6.037c2.285 0 4.43.623 5.64 1.5-.286.386-.809.73-1.543 1-1.085.4-2.545.62-4.11.62-1.567 0-3.027-.22-4.112-.62-.71-.263-1.223-.593-1.514-.964 1.166-.902 3.304-1.536 5.639-1.536zm.047-1.739c1.565 0 3.025.24 4.11.676 1.101.442 1.724 1.06 1.783 1.75-1.462-.964-3.751-1.513-5.94-1.513-2.151 0-4.4.544-5.845 1.5.066-.684.688-1.298 1.781-1.737 1.086-.436 2.546-.676 4.11-.676zM15.568 1a2.83 2.83 0 012.827 2.828 2.83 2.83 0 01-2.827 2.828 2.831 2.831 0 01-2.828-2.828A2.832 2.832 0 0115.568 1z" id="mdCombined-Shape"></path></g></svg>
					</a>
				</li>
				` : '',
				tag.includes('iconrecycled') ? 
				productMaterialInfo += `
				<li class="nav-item" role="presentation">
					<a class="nav-link" id="recycled-tab" data-bs-toggle="tab" href="#recycledTab" role="tab" aria-controls="recycledTab" aria-selected="true">
						<svg viewBox="0 0 32 32" id="icon--ser--recycled" xmlns="http://www.w3.org/2000/svg"><title>Recycled</title><g id="mhicons-/-black-/-SER-/-Recycled" stroke="none" stroke-width="1" fill-rule="evenodd"><path d="M26.4 15.916a.698.698 0 01.854.343l.933 1.836a5.889 5.889 0 01.077 5.526.677.677 0 01-.049.104l-.148.251c-1.107 1.832-3.034 2.92-5.166 2.865l-2.796-.027-.042 2.499a.698.698 0 01-1.155.516l-6.122-5.301a.698.698 0 01.035-1.085l6.237-4.733a.699.699 0 011.121.56l-.012 2.27 2.813.028a.593.593 0 00.557-.293.619.619 0 00.022-.652h.002l-1.024-1.766a2.768 2.768 0 01-.077-.129l-.103-.198a.83.83 0 01-.135-.79c.059-.166.2-.395.537-.538.058-.025.236-.1 3.54-1.251zm-7.625 4.764l-4.423 3.356 4.339 3.757.028-1.697a.7.7 0 01.698-.687h.008l3.495.035a4.487 4.487 0 003.947-2.185l.106-.178a.47.47 0 01.025-.053c.04-.077.07-.158.106-.237a2.513 2.513 0 01-.79.137l-3.62.045a.739.739 0 01-.132-.011l-3.104-.032a.698.698 0 01-.691-.702l.008-1.548zm-7.73-10.62a.7.7 0 01.935.551l1.155 7.745a.7.7 0 01-1.03.713l-1.985-1.1-.719 1.28-.006.016-.658 1.171a.613.613 0 00-.004.615c.13.224.321.333.56.333l1.621-.078c.08-.004.111-.005.144-.005l.222.005a.94.94 0 01.135-.01.83.83 0 01.622.27c.118.132.252.365.215.73-.016.162-.167 1.042-.555 3.246l-.09.514a.698.698 0 01-.681.583l-1.608.018a5.904 5.904 0 01-4.914-2.588.696.696 0 01-.067-.092l-.149-.25a5.863 5.863 0 01-.031-5.907l1.368-2.44-2.172-1.237a.7.7 0 01.102-1.262zm-3.25 12.057l-.665 1.184c-.127.235-.463 1.058.614 1.677l.01.007a4.55 4.55 0 001.549.275l1.027-.012c.105-.598.32-1.813.442-2.535l-1.443.068a2.04 2.04 0 01-1.535-.664zm2.93-10.447l-5.38 1.999 1.475.84c.334.19.452.614.263.95l-1.71 3.048a4.478 4.478 0 00.02 4.512l.106.179c.013.015.025.03.035.046.031.048.07.09.102.136.056-.288.155-.552.278-.767l1.6-2.853c.005-.009.008-.017.014-.026l1.714-3.055a.699.699 0 01.948-.27l1.353.752-.818-5.491zm15.56 5.766c-1.3.453-2.036.713-2.451.86l.943 1.642c.28.512.33 1.085.16 1.61l1.367-.018c.266-.006 1.123-.127 1.147-1.321a4.558 4.558 0 00-.517-1.496zM15.945 3l.29.003c2.141.052 4.027 1.195 5.054 3.06l1.365 2.441 2.19-1.206a.699.699 0 011.022.747l-1.558 7.946a.698.698 0 01-.96.509l-7.206-3.061a.698.698 0 01-.07-1.252l1.974-1.118-1.372-2.454a.615.615 0 00-.532-.338.609.609 0 00-.575.302l-.914 1.6a2.341 2.341 0 01-.069.124l-.12.188a.971.971 0 01-.063.12.825.825 0 01-.555.388c-.175.033-.443.025-.735-.197a318.91 318.91 0 01-2.966-2.436.699.699 0 01-.128-.906l1.052-1.632a5.941 5.941 0 011.308-1.488.693.693 0 01.225-.201c.042-.023.082-.04.123-.06a5.861 5.861 0 013.106-1.07.684.684 0 01.113-.009zM16 4.398a.548.548 0 01-.057.005c-.058.002-.114.013-.171.017a2.5 2.5 0 01.476.6l1.772 3.124c.014.024.022.05.032.075l1.553 2.775a.698.698 0 01-.266.95l-1.348.762 5.11 2.17 1.105-5.632-1.487.82a.699.699 0 01-.947-.272l-1.706-3.05a4.477 4.477 0 00-3.857-2.34zm-.97 1.306c-.13-.22-.62-.876-1.606-.415-.46.341-.859.77-1.17 1.275-.001.005-.004.009-.007.013a.564.564 0 01-.033.047l-.689 1.072c.55.455 1.454 1.2 1.995 1.641l.842-1.467a2.011 2.011 0 011.357-.95z" id="mhCombined-Shape"></path></g></svg>
					</a>
				</li>  
				` : '',
				tag.includes('iconhemp') ? 
				productMaterialInfo += `
				<li class="nav-item" role="presentation">
					<a class="nav-link" id="hemp-tab" data-bs-toggle="tab" href="#hempTab" role="tab" aria-controls="hempTab" aria-selected="true">
						<svg version="1.1" id="hemp" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
							viewBox="0 0 700 700" style="enable-background:new 0 0 700 700;" xml:space="preserve">
							<path d="M438.9,389.6c1.3-1.2,2.1-1.8,2.8-2.5c58.8-58.6,129.9-95.4,209.3-117.4c6.1-1.7,12.1-4.2,18.9-2.8
							c11.2,2.5,18.6,13.7,16.3,24.9c-12.1,61-39,114.6-80.3,160.9c-19.1,21.4-40.6,40.3-64.3,56.6c-1.2,0.8-2.3,1.7-4,3
							c7.8,0.8,15,1.4,22.2,2.2c34.1,4.2,66.1,14.3,94.5,34.2c11.7,8.2,13.2,23.1,3.1,33.5c-9.7,10-21.5,17.3-33.8,23.4
							c-29.8,14.8-61.2,24.2-94.1,28.8c-16.6,2.3-33.2,4-50,3.3c-36.1-1.3-70.5-9-102.4-26.6c-1-0.6-2.1-1.1-3.1-1.6
							c-0.2-0.1-0.6-0.1-1.3-0.2c-0.1,1.5-0.2,3.1-0.2,4.6c0,21.3,0.1,42.6,0,63.8c0,10.5-6.6,18.8-16.2,20.8c-14,2.9-25.9-6.9-26-21.6
							c-0.1-21.9,0-43.7,0-65.6c0-1.6,0-3.2,0-5.6c-3.1,1.8-5.7,3.3-8.4,4.8c-23.4,13.3-48.5,21.2-75.1,24.6c-62.7,8-121.9-4.1-177.8-32.9
							c-9.9-5.1-18.9-12.3-27.2-19.8c-11.7-10.5-9.7-25.4,3.2-34.2c28.3-19.5,59.9-29.6,93.7-33.8c7.5-0.9,15.1-1.6,23.7-2.4
							c-2.5-1.8-4.5-3.2-6.4-4.6c-32.5-23.2-60.9-50.6-84.5-82.8c-24.8-33.9-42.3-71.2-53-111.8c-1.8-6.6-3.3-13.4-4.6-20.1
							c-3.3-16.8,10.2-29.8,26.9-25.4C109,285.3,172.1,314,227,359c9.9,8.1,19.1,16.9,28.5,25.5c1.7,1.6,2.9,3.7,4.3,5.5
							c0.6-0.4,1.1-0.7,1.7-1.1c-1-4.8-1.9-9.7-3-14.5c-9.6-42.6-14.7-85.8-13.8-129.5c1.3-63.1,15.9-122.7,47.2-177.8
							c11.9-21,25.9-40.5,41.7-58.8c8.8-10.2,25-9.7,33.7,0.6c25,29.5,45.6,61.8,60.4,97.6c11.1,26.8,18.5,54.6,23,83.2
							c4.6,29.5,6.5,59.3,4.1,89c-2,25.5-5.7,50.9-9.2,76.3c-1.4,10.1-4.1,20-6.2,30.1C439.2,386.3,439.2,387.6,438.9,389.6z M349.8,534.2
							c4.5-11.2,8.7-21.2,12.5-31.3c23.3-61,40.5-123.5,47.2-188.7c4.2-40.6,4.1-81.1-2.7-121.4c-7.7-45.9-23.5-88.5-49.6-127.2
							c-2.2-3.3-4.6-6.6-7.5-10.7c-7.5,12-15,22.9-21.4,34.4c-24.7,44.5-36.8,92.6-40.4,143.1c-3.3,46.2,1.2,92,10.2,137.3
							c8.1,40.9,19.9,80.7,34.3,119.8C337.8,504.2,343.7,518.6,349.8,534.2z M65.3,318.8c-0.5,0.3-0.9,0.6-1.4,0.9
							c5.6,12.9,10.6,26,16.7,38.6c21,43.3,51.2,79,89.5,108.1c34.2,26,72.1,44.7,112.5,58.8c8.6,3,17.4,5.7,27.2,8.8
							C259.2,425.6,176.7,355.8,65.3,318.8z M635.4,318.6c-112.1,37.2-194.5,106.9-244.9,214.5c1.8-0.2,2.5-0.2,3.2-0.4
							c30.5-9.2,60.2-20.3,88.3-35.6c52.8-28.7,96.2-67.2,126.9-119.3C619.8,359.3,628.5,339.8,635.4,318.6z M298,575.2
							c-1.3-0.5-2-0.8-2.6-1c-31.2-10-63-17.1-95.7-19.4c-24.4-1.8-48.6-1.3-72.6,3.7c-3.6,0.7-7.1,1.7-10.7,2.6c-3.7,1-7.3,2.1-10.9,3.4
							c-3.3,1.2-6.5,2.6-10.3,4.1c25.4,11.9,51.2,19.5,78.2,23.6c31,4.7,61.6,4.1,92-3.9C276.5,585.4,287.2,581.2,298,575.2z M399.9,575.1
							c2.2,1.2,3.4,2,4.6,2.6c23.5,11.6,48.7,16.7,74.7,17.6c36.2,1.2,71-6.1,104.9-18.4c6.3-2.3,12.4-5.2,19.1-8.1
							c-19.3-8.5-46.6-14-68.7-14.7c-34.7-1.2-68.7,3.5-102.2,11.8C421.7,568.4,411.4,571.8,399.9,575.1z"/>
						</svg>
					</a>
				</li>  
				` : '',
				tag.includes('iconorganic') ? 
				productMaterialInfo += `
				<li class="nav-item" role="presentation">
					<a class="nav-link" id="organic-tab" data-bs-toggle="tab" href="#organicTab" role="tab" aria-controls="organicTab" aria-selected="true">
					<svg version="1.1" id="organic" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
						viewBox="0 0 700 700" xml:space="preserve"><title>Organic</title>
						<path d="M332.1,644.1c-20.9-7.7-38.6-19.9-56.1-32.4c-43.3-31-80.1-68.3-108.6-113.5c-25.3-40.1-41.5-83.6-47.8-130.7
						c-12.1-89.6,10.6-170,64.1-242c36-48.4,80.6-87.2,133.7-115.9c21.3-11.5,43.4-11.5,64.9-0.2c32.6,17,61.5,39.1,88.1,64.4
						c37.3,35.5,67.6,76,87.7,123.7c15.1,35.7,24,72.8,25.4,111.7c2.9,80.9-21.4,153.3-70.5,217.2c-35.5,46.3-79.2,83.5-130.6,111.5
						c-4.2,2.3-8.7,4-13.7,6.2c0,11.5,0.1,23.6,0,35.6c-0.1,10-5.8,17.3-14.6,19c-11.1,2.2-21.3-5.6-21.7-17c-0.4-10.7-0.1-21.4-0.2-32
						C332.1,647.6,332.1,645.7,332.1,644.1z M369.2,453.6c39.9-72.6,95-127,177.7-148.9c-3.6-41.7-14.4-81.2-34.9-118.2
						c-3.5,1.4-6.5,2.4-9.4,3.8c-4.3,2.1-8.7,4.2-12.7,6.7c-36.6,22.5-64.6,53.5-85.4,90.7C375.8,339.2,364.9,394.8,369.2,453.6z
						M187.8,186.5c-20.1,37.3-31.5,76.7-34.7,118.8c40.2,8.6,74.1,28.7,104.6,55.1c30.5,26.4,54.6,58,73.4,95.2c0.4-2.2,0.6-2.9,0.6-3.6
						c0-26.5-0.6-53-5.8-79.1c-12.9-63.9-42.5-118-93.3-159.7C219.2,202.3,204.9,192.8,187.8,186.5z M546.3,342.9
						c-5.1,1.7-9.4,2.8-13.4,4.5c-63.7,26.6-108,73-136.5,135.2c-12.7,27.8-20.1,57.3-24.2,87.6c-1.5,10.6-1.9,21.4-3,33.2
						c2.9-1.6,4.6-2.4,6.3-3.4c38.5-22.5,71.8-51.2,100.3-85.4c27.6-33.1,48.2-69.9,60.1-111.4C541.3,383.8,545.1,364.2,546.3,342.9z
						M330,603.3c0-2.2,0.1-3.4,0-4.6c-1.6-31.4-6.8-62.2-17.2-91.9c-24.4-69.4-68.3-122-134.9-154.7c-7.5-3.7-15.6-6-23.9-9.2
						c1.8,39.5,14.5,93.1,50.4,145.6C237.1,536.3,279.2,573.9,330,603.3z M331.4,43.1c-49.5,28.8-91.1,65.1-124.1,111.5
						c55.2,26.7,94.4,69,124.1,123C331.4,198.6,331.4,121.4,331.4,43.1z M368.9,43.2c0,78,0,155,0,232.7c29.9-52.6,68.3-95.5,123.7-121.3
						C459.7,108,418,72.1,368.9,43.2z"/>
					</svg>
					</a>
				</li>    
				` : '',
				tag.includes('iconresponsiblewool') ? 
				productMaterialInfo += `
				<li class="nav-item" role="presentation">
					<a class="nav-link" id="reponsible-wool-tab" data-bs-toggle="tab" href="#reponsible-woolTab" role="tab" aria-controls="reponsible-woolTab" aria-selected="true">
						<svg version="1.1" id="Responsible_Wool" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
							y="0px" viewBox="0 0 700 700" style="enable-background:new 0 0 700 700;" xml:space="preserve"><title>Responsible Wool</title>
							<g>
								<path d="M461.3,254.2c16.2-1.5,30.6,3.3,44.5,10.3c3.4,1.7,6.8,3.6,10.1,5.5c9,5,11.5,15.2,5.4,23.5
								c-10.4,14.3-23.3,25.5-40.5,30.9c-5.6,1.7-11.4,2.5-17.7,3.9c-1.3,7-2.5,14.6-4,22c-8.8,44.3-25.7,85.1-53.8,120.8
								c-9.6,12.2-20.9,22.6-35.8,28.1c-16.2,6-31.4,3.5-45.9-5.1c-15.7-9.4-26.6-23.5-36.7-38.2c-19.4-28.4-31.3-60-39.1-93.3
								c-2.5-10.7-4.3-21.5-6.2-32.3c-0.4-2.5-1.5-2.8-3.5-2.9c-9.7-0.3-19-2.3-27.8-6.6c-13.2-6.5-23.8-16-32-28
								c-5.3-7.7-3.3-17.5,4.5-22.1c11.7-7,23.8-13.3,37.3-15.5c6.3-1,13-0.9,19.4-0.5c3.6,0.2,3.7-1.7,4.3-3.9
								c5.9-20.7,18.2-35.8,38.2-44.4c9.6-4.1,19.8-6.4,30.2-6.9c17.9-0.9,35.8-2.1,53.7-1.4c14.9,0.5,29.9,2.3,44.5,5.5
								c26.4,5.8,43.3,22.5,50.3,48.8C460.8,252.9,461,253.4,461.3,254.2z M341.1,235.9c-12.2,1.2-22.6,2.2-33,3.4
								c-15.3,1.8-26.4,9.1-29.5,25.1c-1.6,7.8-3.4,16.1-2.5,23.8c1.6,14.2,13,23,28.5,23.2c6.7,0.1,11,3.2,13.6,8.7
								c1.6,3.4,2.5,7.2,3.1,11c1.5,10.5-4.2,17.3-14.6,18.3c-1.3,0.1-2.6,0.2-3.8,0.3c-8.5,0.7-13.6,5.6-14.1,14.3c-0.2,3,0,6.2,0.9,9.1
								c8.2,26.6,19.5,51.8,37.6,73.3c4.6,5.5,10.3,10.3,16.1,14.5c5.8,4.2,12.5,4.1,18.3-0.4c5.4-4.2,10.7-8.8,15.2-14
								c16.1-19.1,26.8-41,34.2-64.7c1.7-5.3,3.3-10.8,3.6-16.4c0.6-9.5-5-15.1-14.5-15.7c-1.7-0.1-3.3-0.2-5-0.4
								c-5.8-0.4-9.7-3.5-11.9-8.8c-5.2-12.8,3-27.3,16.5-29.3c0.9-0.1,1.8-0.2,2.7-0.4c13.5-2.1,23.1-10.6,25.3-23.3
								c1.5-8.7-0.3-17.3-2.5-25.7c-2.9-10.7-9.8-17.6-20.7-19.9c-6.7-1.4-13.6-2.3-20.5-2.9C369.1,237.7,354.3,236.9,341.1,235.9z"/>
								<path d="M600.4,378.5c0.3-9.1,1-18.1,0.9-27.2c-0.5-33.9-7.4-66.5-20.9-97.7c-15.4-35.6-37.9-66-67.2-91.4
								c-32.5-28.1-69.9-46.7-111.9-55.6c-27.5-5.8-55.3-6.7-83.2-2.8c-56.9,7.9-105.4,32.5-145.8,73.2c-21.4,21.6-38.1,46.5-50.4,74.2
								c-3.4,7.6-9,11.7-17.4,11.4c-11.9-0.5-19.3-12.9-14.4-24.4c7-16.5,15.8-32.2,26-47c29.3-42.6,67.3-75.2,114-97.4
								c30.7-14.6,63-23.3,96.9-26c56.3-4.6,109.3,6.4,158.8,33.4c37.6,20.4,68.9,48.2,94.2,82.7c22.2,30.4,38.2,63.9,47.2,100.5
								c7,28.4,10.1,57.2,8.2,86.4c-0.1,1.1,0,2.3,0,3.4c0.4,0.4,0.8,0.7,1.1,1.1c0.7-1.1,1.2-2.5,2.1-3.4c10.1-10.5,20.3-21,30.6-31.4
								c8.1-8.1,18.9-7.7,25.9,0.5c4.9,5.8,5.4,14.5,1,20.7c-0.9,1.3-1.9,2.4-3,3.5c-21.1,21.7-42.3,43.2-63.1,65.1
								c-8.4,8.8-19.6,8.5-27.9,0.1c-21.3-21.5-42.9-42.6-64.3-63.9c-10.1-10.1-6.6-25.8,6.7-29.8c6.8-2,12.6,0.3,17.5,5.1
								c11.5,11.4,22.9,22.7,34.4,34.1c1,1,2,1.9,3,2.8C599.7,378.7,600.1,378.6,600.4,378.5z"/>
								<path d="M64.6,389.9c-11,10.9-21.9,21.6-32.7,32.3c-5.2,5.2-11.1,7.7-18.4,5.6c-12.3-3.6-16.7-18.5-7.8-27.6
								c21.8-22.4,43.9-44.5,66.1-66.5c7.4-7.3,17.4-7.4,24.8-0.3c22.4,21.3,44.6,42.7,66.8,64.1c6.9,6.7,7.6,15.5,2.4,22.6
								c-5,6.8-14.5,9.1-22,5.1c-2-1.1-3.8-2.7-5.4-4.2c-12.3-11.6-24.5-23.3-36.7-35c-0.8-0.8-1.7-1.5-2.9-2.6
								c4.6,33.8,14.9,65,32.4,93.7c36.8,60.4,90.1,98.6,158.5,115.7c24,6,48.6,7.8,73.2,6.1c56.8-3.8,107.2-23.8,150.5-61.2
								c17-14.6,31.6-31.3,44.1-49.9c4.4-6.6,10.4-9.8,18.3-8.4c12.4,2.1,18.1,15.7,11,26.4c-16.8,25.1-36.9,47.1-60.6,65.9
								c-26.9,21.3-56.7,37-89.3,47.6c-21.2,6.9-43,11.3-65.3,12.9c-21.8,1.6-43.5,1.4-65.1-1.8c-27.2-4-53.4-11.6-78.5-23
								c-41.6-18.9-76.5-46.3-105-81.9c-26.4-33-44.2-70.2-53.7-111.4C67.4,406.1,66.2,398.1,64.6,389.9z"/>
							</g>
						</svg>
					</a>
				</li>      
				` : '',
				tag.includes('icontraceabledown') ? 
				productMaterialInfo += `
				<li class="nav-item" role="presentation">
					<a class="nav-link" id="traceable-down-tab" data-bs-toggle="tab" href="#traceable-downTab" role="tab" aria-controls="reponsible-woolTab" aria-selected="true"></a>
				</li>       
				` : ''
			});
							
			productMaterialInfo += '</ul><div class="tab-content" id="TabTagsProdContent">';
			tags.forEach( tag => {
				tag.includes('iconfairtrade') ? 
				productMaterialInfo += `
				<div class="tab-pane fade" id="fairtradeTab" role="tabpanel" aria-labelledby="fairtrade-tab">
					<div class="h9">
					Comercio justo
					</div>
					<p>El 87% de nuestra línea está cosida con Fair Trade Certified™️.</p>                        
				</div>
				` : '',
				tag.includes('iconrecycled') ? 
				productMaterialInfo += `
				<div class="tab-pane fade" id="recycledTab" role="tabpanel" aria-labelledby="recycled-tab">
					<div class="h9">
					Reciclado
					</div>
					<p>El 87% de nuestra línea utiliza materiales reciclados.</p>                        
				</div>
				` : '',
				tag.includes('iconhemp') ? 
				productMaterialInfo += `
				<div class="tab-pane fade" id="hempTab" role="tabpanel" aria-labelledby="hemp-tab">
					<div class="h9">
					Cañamo
					</div>
					<p>En Patagonia, dependemos del cáñamo para fabricar algunas de nuestras prendas más resistentes, ligeras y respirables.</p>                        
				</div>
				` : '',
				tag.includes('iconorganic') ? 
				productMaterialInfo += `
				<div class="tab-pane fade" id="organicTab" role="tabpanel" aria-labelledby="organic-tab">
					<div class="h9">
					Orgánico
					</div>                   
				</div>  
				` : '',
				tag.includes('iconresponsiblewool') ? 
				productMaterialInfo += `
				<div class="tab-pane fade" id="reponsible-woolTab" role="tabpanel" aria-labelledby="reponsible-wool-tab">
					<div class="h9">
					Lana responsable
					</div>
					<p>Exigimos que toda nuestra lana esté certificada según la Norma de Lana Responsable (RWS). Menos del 1% de la lana utilizada en el mundo tiene la certificación RWS.</p>                        
				</div>     
				` : '',
				tag.includes('icontraceabledown') ? 
				productMaterialInfo += `
				<div class="tab-pane fade" id="traceable-downTab" role="tabpanel" aria-labelledby="traceable-down-tab">
					<div class="h9">
					Plumón trazable
					</div>
					<p>El 100% del plumón virgen de nuestros productos está certificado según la norma Global Traceable Down Standard (TDS). Ninguna otra empresa de ropa outdoor utiliza únicamente material certificado Global TDS para su plumón virgen.</p>                        
				</div>     
				` : ''
			});
			productMaterialInfo += '</div>';
		
			return productMaterialInfo;
		}
		*/

		function renderOptions(product, variantTitle) {
			let optionsEl = '';
			const values = variantTitle.split("/");

			product.options_with_values.forEach((option,index) => {
					let rawValue = values[index];
					let displayValue = rawValue;

					if (option.name?.toLowerCase() === "color") {
						displayValue = window.translateColor(rawValue);
					}
				optionsEl += `<p class="variants ccg ${option.name}-${rawValue}">
								${option.name}: <span>${displayValue}</span>
								<span class="divider">|</span>
							</p>`;
			});
			return optionsEl;
		};

		const productItems = document.querySelectorAll(".boost-pfs-filter-product-item-grid");
		productItems.forEach( item => {
			const saleEl = item.querySelector(".on-sale");
			const colorOption = item.querySelector("[js-upper]");
			if(colorOption){
				saleEl ? saleEl.querySelector("span").click() : colorOption.querySelector("span").click();
			}
		});

		/*var cambiar = $(".main-pdp-popup .options .variants:nth-child(2)").html().replace('Size','Talle'); // Obtenemos el texto a cambiar
            $(".main-pdp-popup .options .variants:nth-child(2)").html(cambiar); // Cambiamos el texto*/
	};

    // Filter Sticky
  jQ.fn.stickTo = function(startElement, stickyElementParent) {
    /* constants */    
    var showingHeader = false;
    var headerHeight = 0; /* change the header height here */
    var headerSelector = '';  
    var $window = jQ(window);  
    var $startElement = jQ(startElement);               
    var _this = this;          

    /* variables */
    var lastScrollTop = window.pageYOffset || document.body.scrollTop;  

    /* sticky method */
    var setPosition = function() {
      /* declarations */
      var width = jQ(stickyElementParent).outerWidth();
      var $windowHeight = $window.height();
      var $contentHeight = $startElement.outerHeight(true);     
      var $contentTop = $startElement.offset().top;      

      var sidebarHeight = _this.outerHeight();
      var sidebarTop = _this.offset().top;
      var sidebarBottom = sidebarTop + sidebarHeight;

      var scrollTop = window.pageYOffset || document.body.scrollTop;                        
      var scrollBottom = scrollTop + $windowHeight;  
      var isScrollingDown = (scrollTop > lastScrollTop);

      var endPos = $contentTop + $contentHeight;
      
      /* Match Header Height Sticky */
      if(jQ('.site-header-wrapper .action-area').length > 0){
      /* For the Boundless theme */
          headerSelector = '.site-header-wrapper .action-area';
        } else if (jQ('.site-header .nav-bar').length > 0) {
      /* For the Venture theme */
          headerSelector = '.site-header .nav-bar';
      } else if (jQ('.site-header--fixed').length > 0) {
        headerSelector = '.site-header--fixed';
      } else if (jQ('.header-wrapper--fixed').length > 0) {
        headerSelector = '.header-wrapper--fixed';
      }

      if(headerSelector != ''){
      headerHeight = jQ(headerSelector).outerHeight();
      }

      document.addEventListener('scroll', function() {
        showingHeader = false;
        /* For the Boundless, Venture theme */
        if(jQ('.js-sticky-action-bar').length > 0 || jQ('.site-header .sticky--open').length > 0 || jQ('.site-header--fixed' || jQ('.header-wrapper--fixed'))){
            showingHeader = true;
        }
      });
      /* End Match Header Height Sticky */

      if (sidebarHeight > $contentHeight) {
        _this.removeClass('boost-pfs-filter-stick');
        jQ('body').removeClass('boost-pfs-filter-stick-vertical-body');           
        _this.css({
        position: 'initial'
        });
        return;
      }

      if (scrollTop <= $contentTop) { /* Initial Position */
        _this.removeClass('boost-pfs-filter-stick');
        jQ('body').removeClass('boost-pfs-filter-stick-vertical-body');          
        _this.css({
          position: 'initial',
          width: '100%'
        });
        return;
      }      

      if ((scrollBottom >= endPos)) { /* End Position  */          
        var absolutePos = endPos - sidebarHeight - $contentTop;
        if (absolutePos > 0) {
          _this.removeClass('boost-pfs-filter-stick');
          jQ('body').removeClass('boost-pfs-filter-stick-vertical-body');            
          _this.css({
            position: 'absolute',
            top: absolutePos,
            bottom: 'unset',
            width: width
          });
        } 
        return;
      }
      /* when scrolling down */  
      if (isScrollingDown) {          
        if (scrollBottom < sidebarBottom) { /* Until reach the sidebar bottom  */
          if (_this.css('position') !== 'relative') {
            _this.removeClass('boost-pfs-filter-stick');
            jQ('body').removeClass('boost-pfs-filter-stick-vertical-body');          
            _this.css({
              position: 'relative',
              top: sidebarTop - $contentTop,
              bottom: 'unset',
              width: '100%'
            });          
          }
        } else if (scrollBottom >= sidebarBottom && scrollTop > $contentTop) { /* Sticky sidebar */                
          _this.addClass('boost-pfs-filter-stick');
          jQ('body').addClass('boost-pfs-filter-stick-vertical-body');                        

          _this.css({
            position: 'fixed',
            top: showingHeader ? (headerHeight + 'px') : '20px',
            bottom: $windowHeight > (sidebarHeight + headerHeight) ? 'unset' : 0,
            width: width,
            left: 'auto'
          });
        }
      } else { /* when scrolling up */     
        if ((scrollTop - headerHeight) > sidebarTop) {  /* Until reach the sidebar top  */   
          if (_this.css('position') !== 'relative') {
            _this.removeClass('boost-pfs-filter-stick');
            jQ('body').removeClass('boost-pfs-filter-stick-vertical-body');           
            _this.css({
              position: 'relative',
              top: sidebarTop - $contentTop,
              bottom: 'unset',
              width: '100%'
            });          
          }
        } else if (scrollTop <= (endPos - sidebarHeight)) { /* Sticky sidebar */
          _this.addClass('boost-pfs-filter-stick');
          jQ('body').addClass('boost-pfs-filter-stick-vertical-body');                        

          _this.css({
            position: 'fixed',
            top:  showingHeader ? (headerHeight + 'px') : '20px',
            bottom: 'unset',
            width: width,
            left: 'auto'
          });
        }
      }
      /* End when scrolling down */ 
      /* save last scroll position */
      lastScrollTop = window.pageYOffset || document.body.scrollTop;
    };

    /* on window resize */
    jQ(window).resize(function() {        
      setPosition();
    });

    /* on scroll */
    document.addEventListener('scroll', function() {
      setPosition();
    });
    setPosition();
    
    jQ(document).on('click', '.boost-pfs-filter-button.boost-pfs-filter-option-title-heading', function() {
        setTimeout(setPosition, 400);
    });
  };
	/* End filter sticky */

    var original_onClickEventProductDisplayType = ProductDisplayType.prototype._onClickEvent;
    ProductDisplayType.prototype._onClickEvent = function(event) {
        // Call the original function in our app lib.
        // We don't have to copy a very big function out here to modify.
        // function.call(this, param1, param2) binds the "this" pointer and params to the original function.
        original_onClickEventProductDisplayType.call(this, event);

        // Do your custom code after the original function has run
        /*  View As Type 2/3/4/5/6 */
        if (boostPFSThemeConfig.custom.view_as_type == 'view_as_type_list_grid_multi_col' && !Utils.isMobile()) {
            jQ('.boost-pfs-filter-top-display-type').addClass('boost-pfs-filter-view-as-click');
            jQ('.boost-pfs-filter-top-display-type').removeClass(function(index, css) {
                return (css.match (/(^|\s)grid-\S+/g) || []).join(' ');
            }).addClass(jQ(event.target).data('view'));
        }
    }

	ProductListPlaceholder.prototype.render = function() {
		// Set limit number for product skeleton
		var placeholderLimit = this.settings.productsPerRow || this.settings.placeholderProductPerRow;
		// Build placeholder items
		var placeholderItem = this.compileTemplate();
		this.$element = [];
		for (var i = 0; i < placeholderLimit; i++) {
			this.$element.push(jQ(placeholderItem));
		}
		// Show placeholder before send filter request OR hide it after get filter data
		if (!this.isFetchedProductData) {
			this.setShow();
		} else {
			this.setHide();
		}
	}

	ProductListPlaceholder.prototype.compileTemplateExtra = function() {
		var display = Globals.queryParams.display
		switch (display) {
			case 'list':
				//Todo: Build placeholder for List mode
				var template = boostPFSTemplate.productListPlaceholderHtml;
				var imgRatioSetting = parseFloat(this.settings.placeholderImageRatio);
				var imgRatio = imgRatioSetting > 0 ? imgRatioSetting : 1.4; // It mean w1:h1.4
				/**
				 * Set product class for product skeleton (to set column, style, etc.)
				 * - If had defined product_grid_class in boostPFSThemeConfig => use this config ELSE use our setting
				 */
				break;
		}
		return template
			.replace(/{{class.filterProductSkeleton}}/g, Class.filterProductSkeleton)
			.replace(/{{class.filterSkeleton}}/g, Class.filterSkeleton)
			.replace(/{{class.filterSkeletonText}}/g, Class.filterSkeletonText)
			.replace(/{{paddingTop}}/g, imgRatio * 100)
	}

	/* Prevent conflict with theme vendor js */
	Array.prototype.insert = function(a, b) {}

	/* Math qual Height */
	function equalHeight(data) {
		var equal_i = -1;
		var equal_els = [];
		var equal_element = null;

		// Equal Height Title
		jQ('.boost-pfs-filter-product-item').each(function(i, element) {

			var offsetTop = jQ(element).offset().top;
			if (!equal_element || equal_element.offset().top !== offsetTop) {
				equal_element = jQ(element);
				equal_i++;
			}

			if (!equal_els[equal_i]) {
				equal_els[equal_i] = [];
			}
			equal_els[equal_i].push(element);
		});

		for (var i = 0; i < equal_els.length; i++) {
			var max = 0;
			var maxRatio = 0;
			var iLength = equal_els[i].length;

			for (var j = 0; j < equal_els[i].length; j++) {
				var item = equal_els[i][j];
				var height = jQ(item).find('.boost-pfs-filter-product-bottom-inner').height();
				max = Math.max(max, height);

			}

			jQ(equal_els[i]).find('.boost-pfs-filter-product-bottom-inner').css({ 'min-height': max });

		}

		var equal_height = boostPFSFilterConfig.general.equal_height;

		if (equal_height != 'false') {
			var cropImagePosition = boostPFSFilterConfig.general.cropImagePossitionEqualHeight;

			var widthImage = jQ('.boost-pfs-filter-product-item').width();
			var indexData = 0;

			// For Ratio
			if (equal_height != 'false' && equal_height != 'auto') {
				var heightImage = 0;
				var widthImage = jQ('.boost-pfs-filter-product-item').width();
				if (equal_height != 'false' && equal_height != 'auto' && equal_height != 'other') {
					var ratioWidthHeight = boostPFSThemeConfig.custom.equal_height;
				} else {
					var ratioWidthHeight = '';
				}

				var ratioWidthHeightOther = boostPFSThemeConfig.custom.ratio_width_height_other;
				if (ratioWidthHeightOther == '' && ratioWidthHeight == '') {
					return null;
				} else {
					if (equal_height != 'other') {
						ratioWidthHeight = ratioWidthHeight.split(':');
						ratioWidthHeight = parseInt(ratioWidthHeight[1]) / parseInt(ratioWidthHeight[0]);
						heightImage = widthImage * ratioWidthHeight;
					} else if (ratioWidthHeightOther != '' && equal_height == 'other') {
						ratioWidthHeightOther = ratioWidthHeightOther.split(':');
						ratioWidthHeightOther = parseInt(ratioWidthHeightOther[1]) / parseInt(ratioWidthHeightOther[0]);
						heightImage = widthImage * ratioWidthHeightOther;
					}
				}
				jQ('.boost-pfs-filter-product-item-image-link').css({ 'padding-top': heightImage + 'px' }).addClass('boost-pfs-filter-crop-image-position-' + cropImagePosition);;

			}
		}
	}

	// Swap Image
	function swapImage(data) {
		if (!Utils.isMobile()) {
			if (boostPFSThemeConfig.custom.hasOwnProperty('active_image_swap') &&
				boostPFSThemeConfig.custom.active_image_swap == true) {
				var dataSrcSetFlipImg = '',
					dataSrcFlipImg = '',
					flipImageAlt = '',
					dataSizes = 'auto',
					dataWidths = '',
					html = '';

				jQ(".boost-pfs-filter-product-item").each(function() {
					var productItemSelector = jQ(this);
					var imgSelector = productItemSelector.find('.boost-pfs-filter-product-item-main-image');

					if (typeof imgSelector.data('img-flip-src') != 'undefined' &&
						imgSelector.data('img-flip-src') != '') {
						dataSrcFlipImg = imgSelector.data('img-flip-src');
						dataSrcSetFlipImg = imgSelector.data('img-flip-srcset');
						flipImageAlt = imgSelector.attr('data-img-flip-alt');
						dataWidths = imgSelector.data('widths');

						if(dataSrcSetFlipImg.includes('boost-pfs-no-image')) {
							$(this).addClass('disable-flip')
							html = ''
						}else {
							html = '<img class="boost-pfs-filter-product-item-flip-image"' +
							'data-srcset="' + dataSrcSetFlipImg + '" ' +
							'data-src="' + dataSrcFlipImg + '" ' +
							'data-widths="[' + dataWidths + ']" ' +
							'data-sizes="' + dataSizes + '" ' +
							'src="' + dataSrcFlipImg + '" ' +
							'alt="' + flipImageAlt + '" />';
						}
						
						// console.log("productItemSelector.find('.boost-pfs-filter-product-item')", productItemSelector.find('.boost-pfs-filter-product-item'))
						productItemSelector.find('.boost-pfs-filter-product-item-image-link').append(html);
					}

				});
			}
		}
	}

	// Build Placeholder for the first load
	function boostRemoveImageLoadingAnimation($selector) {
		if ($selector.length) {
			$selector.removeAttr('data-boost-image-loading-animation');
		}
	}
  /* Expand Filter */
    jQ(document).ready(function() {
        jQ('.boost-pfs-filter-custom-filter-button').on('click', function(){
            jQ('body').toggleClass('boost-pfs-filter-custom-drawer-open');
        });
        jQ('.boost-pfs-filter-custom-drawer-close').on('click', function(){
            jQ('body').removeClass('boost-pfs-filter-custom-drawer-open');
        });
        jQ('.boost-pfs-filter-custom-drawer-overlay').on('click', function(){
            jQ('body').removeClass('boost-pfs-filter-custom-drawer-open');
        });
    });

    /* Sticky Filter Mobile */
    function stickyFilterMobile() {
      var windowTop = window.pageYOffset || document.body.scrollTop;
      var heightFooter = 0;
      var divTop = 0;
      var divHeight = 0;
      if(jQ("#shopify-section-footer").length > 0){
        heightFooter = jQ("#shopify-section-footer").height();
      }
      if(jQ(".boost-pfs-filter-wrapper").length > 0){
        divTop = jQ('.boost-pfs-filter-wrapper').offset().top;
      }
      if(jQ(".boost-pfs-filter-wrapper").length > 0){
        divHeight = jQ(".boost-pfs-filter-wrapper").height();
      }

      if (windowTop > divTop + divHeight - heightFooter){
        jQ('body').removeClass('boost-pfs-mobile-stick');
      } else if (windowTop > divTop) {
        jQ('body').addClass('boost-pfs-mobile-stick');
      } else {
        jQ('body').removeClass('boost-pfs-mobile-stick');
      }
    }

    /* Sticky Filter Desktop Horizontal */
    function stickyFilterHorizontal() {
      if(jQ('.boost-pfs-filter-tree-h-sticky-filter').length > 0 && !Utils.isMobile()){
        var windowTop = window.pageYOffset || document.body.scrollTop;
        var divTop = 0;
        if(jQ('.boost-pfs-filter-wrapper').length > 0){
          divTop = jQ('.boost-pfs-filter-wrapper').offset().top;
        }

        if (windowTop > divTop) {
          jQ('body').addClass('boost-pfs-filter-horizontal-sticky-body');
        } else {
          jQ('body').removeClass('boost-pfs-filter-horizontal-sticky-body');
        }
      }
    }
  /* start-boost-custom */
/* #boost-: customize search results */
FilterApi.beforeCall = function(eventType, eventInfo) {
if (Utils.isSearchPage()) {
    Globals.queryParams.q = (Globals.queryParams.q || '').replace(/&#x27;/g, "'").replace(/&#x26;/g, '').replace(/&#x2A;/gi, '').replace(/-/g, ' ');
  }
}

/* end-boost-custom */
    
})();


window.onload = function () {
	const filterInner = document.querySelectorAll('.boost-pfs-filter-product-item-inner')
	filterInner.forEach((ele) => {
		let swatchElement=ele.querySelectorAll('[js-lower]')
		// console.log({swatchElement});
		if(swatchElement && swatchElement.length) {

			swatchElement.forEach((el, index) => {
				if(index == 0) {
					el.querySelector('span').click()
				}
			})
		}

      let swatchElementUpper =ele.querySelectorAll('[js-upper]')
      if( swatchElementUpper && swatchElementUpper.length) {
        // console.log('low',{swatchElement})
		const saleEl = ele.querySelector(".on-sale");
		swatchElementUpper.forEach((el, index) => {
              if(index == 0) {
				saleEl ? saleEl.querySelector('span').click() : el.querySelector('span').click()
              }
          })
      }
	})
};